/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React, { CSSProperties } from 'react';
import { User } from 'firebase/auth';

/* APP E SERVIÇOS */
import { useAppContextoReact } from "../../servicos/app/AppContextoReact.tsx";

/* TEMA */
import appTema from '../../servicos/mui/Theme.ts';
import StyledStack from '../../servicos/mui/StyledStack.tsx';
import { StyledAccordion, StyledAccordionSummary, StyledAccordionDetails } from '../../servicos/mui/StyledAccordion';

/* COMPONENTES */
import Bananinha, { IBananinhaDelegate } from '../../componentes/widgets/Bananinha.tsx';
import AddEditComponent from '../../componentes/formularios/_AddEditComponent.tsx';
import VisuallyHiddenInput from "../../servicos/mui/VisuallyHiddenInput";

/* FORM E FIELDS */
import { Controller, useForm, useFieldArray } from "react-hook-form";
import { Autocomplete, Box, Button, Card, CardContent, FormControl, Grid, IconButton, InputAdornment, InputLabel, Link, MenuItem, Paper, Switch, Tab, Tabs, Tooltip, Typography, useMediaQuery, Zoom } from '@mui/material';
import TextField from '@mui/material/TextField';
import OptionsController, {IOptions} from '../../servicos/forms/OptionsController.ts';
import { PatternFormat } from "react-number-format";

/* INTERFACES E ENUMERAÇÕES */
import { IEntidadesData, IRetornoAjaxEntidades } from '../../servicos/entidades/Entidades_FrontAPI.ts';
import { DataType, ETYPEFORM, IFormStatePrograma, IPropsAnexo, TipoAnexo, bananinhaListError, validacao } from '../../servicos/IFormularios.ts';
import EntidadesController from '../../servicos/entidades/EntidadesController.ts';
import ProgramasController from "../../servicos/programas/ProgramasController";
import {EFORM} from '../../componentes/formularios/EFORM.tsx';
import { IRetornoAjaxProgramas } from "../../servicos/programas/Programas_FrontAPI";

/* ICONS */
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import DeleteIcon from '@mui/icons-material/Delete';
import EmojiObjectsOutlinedIcon from '@mui/icons-material/EmojiObjectsOutlined';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import LaunchIcon from '@mui/icons-material/Launch';
import ChecklistIcon from '@mui/icons-material/Checklist';
import AttachFileIcon from '@mui/icons-material/AttachFile';

/* DATA */
import { LocalizationProvider, DatePicker, DateTimeField, DateTimePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { ptBR } from '@mui/x-date-pickers/locales';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { isEmpty, isUndefined, isNull } from 'lodash';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import TimecodeView from '../../../src/componentes/timecodeView/TimecodeView.tsx';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { PowerInputSharp } from '@mui/icons-material';
import { a11yProps, createSimulatedFileList, filterSeriesOptions, isValidDate, prepararFormDataAnexo, prepararProgramaFormData } from '../../util/formDialogUtil.tsx';

dayjs.extend(utc);
dayjs.extend(timezone);

interface IPropsFormLightbox
{
	operacao: EFORM
	entidade: IFormStatePrograma
	setEntidade: (entidade: IFormStatePrograma) => void
	openDialog: boolean
	listViews: boolean
	setOpenDialog: (openDialog: boolean) => void
	callBack: () => void
}

const FormDialog = (props:IPropsFormLightbox) =>
{
	const appContext = useAppContextoReact();
	const EntController = new EntidadesController();
	const ProgController = new ProgramasController();
	const OptsController = new OptionsController();

	const [user, setUser] = React.useState<User|null|undefined>(null);
	const [userRoleAdmin, setUserRolerAdmin] = React.useState<boolean|null|undefined>(null);
	const [bananinhaDelegate, setBananinhaDelegate] = React.useState<IBananinhaDelegate|undefined>(undefined);
	const [onSubmiting, setOnSubmiting] = React.useState<boolean>(false);
	const [open, setOpen] = React.useState(false);
	const [copied, setCopied] = React.useState<string>(undefined);

	const [operacao, setOperacao] = React.useState<EFORM>(props.operacao);
	const [conteudoFormUpdate, setConteudoFormUpdate] = React.useState<IFormStatePrograma>(props.entidade);
	const [repositorioList, setRepositorioList] = React.useState<IEntidadesData[]>([]);
	const [seriesList, setSeriesList] = React.useState<IEntidadesData[]>([]);
	const [listOptionsTipoPrograma, setListOptionsTipoPrograma] = React.useState<IOptions[]|[]>([]);
	const [listOptionsClassEtaria, setListOptionsClassEtaria] = React.useState<IOptions[]|[]>([]);
	const [listOptionsTipoMidia, setListOptionsTipoMidia] = React.useState<IOptions[]|[]>([]);
	const [listOptionsVigencia, setListOptionsVigencia] = React.useState<IOptions[]|[]>([]);
	const [listOptionsLicenciamento, setListOptionsLicenciamento] = React.useState<IOptions[]|[]>([]);
	const [listOptionsVersao, setListOptionsVersao] = React.useState<IOptions[]|[]>([]);
	const [listOptionsIdioma, setListOptionsIdioma] = React.useState<IOptions[]|[]>([]);
	const [anexoNomeArquivo, setAnexoNomeArquivo] = React.useState<string[]>([]);
	const [expandedAccordion, setExpandedAccordion] = React.useState<string[]>(['programa']);
	const [multipleFilesAnexos, setMultipleFilesAnexos] = React.useState<any[]|[]>([]);
	const [multipleFilesstatus, setMultipleFilesStatus] = React.useState<boolean>(false);

	const { control, handleSubmit, register, reset, setError, setValue, watch, formState: { errors }}
		= useForm<IFormStatePrograma>({reValidateMode: "onSubmit", criteriaMode: "all", shouldFocusError: false, defaultValues: conteudoFormUpdate});

	const { fields: programaTimecodes, append: appendTimecode, remove: removeTimecode } = useFieldArray({ control, name: 'programaTimecodes' });
	const { fields: programaVideos, append: appendProgramaVideo, remove: removeProgramaVideo } = useFieldArray({ control, name: 'programaVideos' });
	
	const { fields: programaAnexos, 		append: appendAnexo, 					remove: removeAnexo } = useFieldArray({ control, name: 'programaAnexos' });


	const [tabItem, setTabItem] = React.useState<number>(0);
	const [tabFormData, setTabFormData] = React.useState<DataType>(DataType.PROGRAMA);

	React.useEffect(() =>
	{
		setUser(appContext?.usuario.user)
		setUserRolerAdmin(appContext.permissao.administrador)
		
	},[appContext])

	React.useEffect(() =>
	{
		if(props.openDialog)
			setOpen(true)
	},[props.openDialog])

	React.useEffect(() =>
	{
		getRepositorio();
		getSeries();
		setListOptionsTipoPrograma(OptsController.tipoPrograma() as IOptions[]);
		setListOptionsClassEtaria(OptsController.classificacaoEtaria() as IOptions[]);
		setListOptionsTipoMidia(OptsController.tipoMidia() as IOptions[]);
		setListOptionsVigencia(OptsController.vigencia() as IOptions[]);
		setListOptionsLicenciamento(OptsController.licenciamento() as IOptions[]);
		setListOptionsVersao(OptsController.versao() as IOptions[]);
		setListOptionsIdioma(OptsController.idiomaVersao() as IOptions[]);
	}, []);

	React.useEffect(() =>
	{
		reset(conteudoFormUpdate);
	}, [conteudoFormUpdate]);

	React.useEffect(() => {
		const { idRepositorio } = control._defaultValues;

		if (idRepositorio === undefined || idRepositorio === null || idRepositorio === '')
			setValue('idRepositorio', 1);
	}, [setValue, control]);

	const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => 
	{
		setTabItem(newValue);

		if(newValue == 0)
			setTabFormData(DataType.PROGRAMA);

		if(newValue == 1)
			setTabFormData(DataType.ANEXOS);
	};

	const handleSuccess = React.useCallback((msgSucesso: string) =>
	{
		setOnSubmiting(false);
		bananinhaDelegate?.abrir(msgSucesso ? msgSucesso : "Item " + (operacao == EFORM.ADD ? "criado" : "alterado") + " com sucesso.", "success");
	}, [bananinhaDelegate])
	
	const handleError = React.useCallback((combinedErrors: string) =>
	{
		setOnSubmiting(false);
		bananinhaDelegate?.abrir(combinedErrors, "error");
	}, [bananinhaDelegate])
	
	const onInvalid = (state: any) =>
	{
		let erroMsg = '<ul>';
		erroMsg += bananinhaListError(state, ETYPEFORM.PROGRAMAS);
		erroMsg += '<ul>';
		handleError(erroMsg)
	}

	async function onSubmit(data:IFormStatePrograma)
	{
		setOnSubmiting(true);
		if (operacao == EFORM.ADD)
		{
			data.idQuemCadastrou = user.uid;
		} else {
			data.idQuemAlterou = user.uid;
		}

		if (!data.aquisicao) data.distribuidor = '';

		if(tabFormData == DataType.ANEXOS)
		{
			let anexosFiltrados = [];

			if(programaAnexos && programaAnexos.length > 0)
				anexosFiltrados = programaAnexos.filter( (anexo:any) => anexo.nome !== "invalid")

			data.programaAnexos = anexosFiltrados;
		}
		
		if(tabFormData == DataType.PROGRAMA)
		{
			delete data.programaAnexos;
		}

		try 
		{
			if (!userRoleAdmin) {
				throw new Error('Usuário não tem permissão para enviar o formulário.');
			}

			var res: IRetornoAjaxProgramas;
			const formData = new FormData();

			if (operacao == EFORM.ADD)
			{
				prepararProgramaFormData(data, formData);

				res = await ProgController.programaCreate(formData);

				if (res && (res.status == 200 || res.status == 201))
				{
					handleSuccess(res.message);

					setConteudoFormUpdate(res.Data as unknown as IFormStatePrograma);
					setOperacao(EFORM.UPDATE);
					setTabFormData(DataType.ANEXOS);
					setTabItem(1);
				}
				else
					handleError(res.message);			
			}
			else
			{
				let res:any;

				if(tabFormData == DataType.ANEXOS)
				{
					prepararFormDataAnexo(data, formData);
					
					res = await ProgController.programaUpdate(formData,DataType.ANEXOS);
				}
				else {
					prepararProgramaFormData(data, formData);

					res = await ProgController.programaUpdate(formData,DataType.PROGRAMA);
				}

				if (res && (res.status == 200 || res.status == 201))
				{
					handleSuccess(res.message);

					setTimeout(() => 
					{
						props.setOpenDialog(false);
						props.setEntidade(null);
					}, 5000);
					
					setOpen(false);
				}
				else
					handleError(res.message);
			}	
		} catch(e) {
			handleError(e.message);
		} finally {
			setOnSubmiting(false);
			props.callBack();
		}
	}

	const getRepositorio = async () =>
	{
		try {
			const res:IRetornoAjaxEntidades = await EntController.repositorioList();
			if (res.status == 200 && res.Data?.rows?.length > 0)
				setRepositorioList(res.Data.rows);
		} catch(e) {
			bananinhaDelegate?.abrir(e, "error");
		}
	}

	const getSeries = async () =>
	{
		try {
			const res:IRetornoAjaxEntidades = await EntController.seriesList();
			if (res.status == 200 && res.Data?.rows?.length > 0)
				setSeriesList(res.Data.rows);
		} catch(e) {
			bananinhaDelegate?.abrir(e, "error");
		}
	}

	const handleAccordion = (id: string) =>
	{
		const pos = expandedAccordion.indexOf(id);
		if (pos == -1) {
			setExpandedAccordion(atual => [...atual, id]);
		} else {
			expandedAccordion.splice(pos, 1);
			setExpandedAccordion(atual => [...expandedAccordion]);
		}
	}
	const handleAppendTimecodeItem = () => {
		appendTimecode({
			dataHora: '',
			versao: '',
			resposta: '',
			texto: '',
			autor: '',
			status: ''
		});
	};
	const handleRemoveTimecodeItem = (index) => {
		removeTimecode(index);
	};
	const handlePaste = (e: any, index:number) => {
		const pastedText = e.clipboardData.getData('text');
		handlePasteAndAddFields(pastedText, (index-1));
		e.preventDefault();
	};
	const handlePasteAndAddFields = (pastedString, fieldIndex) => {
		const lines = pastedString.split('\n');
		lines.forEach((line) => {
			fieldIndex++;
			const [versao, dataHora, timecode, resposta, texto, autor, status] = line.split('\t');
			if (timecode !== undefined && timecode !== "") {
				const parsedDataHora = dayjs(dataHora, 'M/D/YY HH:mm');
				setValue(`programaTimecodes.${fieldIndex}.versao`, versao);
				setValue(`programaTimecodes.${fieldIndex}.dataHora`, parsedDataHora.format('MM-DD-YYYY HH:mm') );
				setValue(`programaTimecodes.${fieldIndex}.timecode`, timecode );
				setValue(`programaTimecodes.${fieldIndex}.resposta`, resposta );
				setValue(`programaTimecodes.${fieldIndex}.texto`, texto );
				setValue(`programaTimecodes.${fieldIndex}.autor`, autor );
				setValue(`programaTimecodes.${fieldIndex}.status`, status );
			}
		});
		handleRemoveTimecodeItem(fieldIndex+1);
	};
	const handleRemoveAnexoItem = (index) => 
	{
		removeAnexo(index);
		setAnexoNomeArquivo((prevAnexos) => {
			const updatedAnexos = [...prevAnexos];
			updatedAnexos.splice(index, 1);
			return updatedAnexos;
		});
	};
	const handleAppendProgramaVideoItem = () => {
		appendProgramaVideo({
			idGsatIdFrm: '',
			path: '',
			link: '',
			size: 0
		});
	};
	const handleRemoveProgramaVideoItem = (index) => {
		removeProgramaVideo(index);
	};

	const isMenorLG = useMediaQuery(() => appTema.breakpoints.down('lg'));
	const isMenorSM = useMediaQuery(() => appTema.breakpoints.down('sm'));

	const copyURL = async (url: string,origem: string, idButton:number) => 
	{
		try 
		{
			// Copia o texto para o clipboard
			await navigator.clipboard.writeText(url);
		
			// Define o estado de "copiado" para verdadeiro para ativar o feedback visual
			setCopied(`${origem}_${idButton.toString()}`);
		
			// Aguarda 1 segundo e redefine o estado para remover o feedback visual
			setTimeout(() => 
			{
				setCopied(undefined);
			}, 1000);
		} 
		catch (err)
		{
			console.error("Erro ao copiar a URL: ", err);
		}
	};

	return <>
		
		<Bananinha getDelegate={delegate => bananinhaDelegate ?? setBananinhaDelegate(delegate)}/>
		{user && conteudoFormUpdate &&
			<>
				<AddEditComponent
					ehDialog={true}
					tituloCaller={(operacao == EFORM.ADD ? "Adicionar" : props.listViews ? "Visualizar" : "Editar") + " Programa"}
					onSubmitingCaller={onSubmiting}
					handleSubmitCaller={handleSubmit(onSubmit, onInvalid)}
					openCaller={open}
					listViews={props.listViews}
					dataType={tabFormData}
					onCloseCaller={() => {
						setOpen(false);
						props.setOpenDialog(false);
						props.setEntidade(null);
					}}
				>
					<Grid item xs={12}>
						<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
							<Tabs value={tabItem} onChange={handleChangeTab} aria-label="basic tabs example">
								<Tab label="Informações do Programa" {...a11yProps(0)} icon={<ChecklistIcon />} iconPosition='start' />
								<Tab label="Anexos" {...a11yProps(1)} disabled={operacao == EFORM.ADD ? true : false} icon={<AttachFileIcon />} iconPosition='start' />
							</Tabs>
						</Box>
					</Grid>
					<CustomTabPanel value={tabItem} index={0}>
						{
						//#region METADADOS PROGRAMA
						}
							<Grid item xs={12}>
								<StyledAccordion defaultExpanded expanded={expandedAccordion.indexOf('programa') >= 0 ? true : false } onChange={() => {handleAccordion('programa')}}>
									<StyledAccordionSummary aria-controls="programa-content" id="programa-header">
										<Typography>Metadados do programa</Typography>
									</StyledAccordionSummary>
									<StyledAccordionDetails>
										<Grid container spacing={2}>
											<Grid item xs={12}>
												<Controller
													name="titulo"
													control={control}
													rules={{
														required: validacao.requerido,
														// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
														maxLength: { value:200, message:`${validacao.maxLength} 200`, }
													}}
													render={({ field }) => (
														<TextField
															{...field}											
															label={'Título do programa *'}
															fullWidth
															size="small"
															inputProps={{
																maxLength:200,
																readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
															}}
															helperText={errors.titulo ? errors.titulo.message : null}
															error={!!errors.titulo}
															aria-invalid={!!errors.titulo}
															value={field.value || ''}
														/>
													)}
												/>
											</Grid>
											<Grid item xs={12} sm={6}>
												{
													listOptionsTipoPrograma &&
														<Controller
															name="tipoPrograma"
															control={control}
															rules={{
																required: validacao.requerido,
															}}
															render={({ field }) => (
																<TextField
																	{...field}
																	SelectProps={{
																		readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual															
																	}}
																	id="tipoPrograma"
																	select
																	label="Tipo de programa *"
																	fullWidth
																	size="small"
																	helperText={errors.tipoPrograma ? errors.tipoPrograma.message : null}
																	error={!!errors.tipoPrograma}
																	aria-invalid={!!errors.tipoPrograma}
																	// value={field.value || 0}
																>
																	<MenuItem value="" sx={{color: appTema.palette.text.disabled}}><em>Selecione uma opção</em></MenuItem>
																	{
																		listOptionsTipoPrograma.map((item:IOptions,keyItem) =>
																			<MenuItem value={item.value} key={keyItem}>{item.name}</MenuItem>
																		)
																	}
																</TextField>
															)}
														/>
												}
											</Grid>
											<Grid item xs={12} sm={6}>
												{
													listOptionsTipoMidia &&
														<Controller
															name="tipoMidia"
															control={control}
															rules={{
																// required: validacao.requerido,
															}}
															render={({ field }) => (
																<TextField
																	{...field}
																	SelectProps={{
																		readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual															
																	}}
																	select
																	label="Tipo de mídia"
																	fullWidth
																	size="small"
																	helperText={errors.tipoMidia ? errors.tipoMidia.message : null}
																	error={!!errors.tipoMidia}
																	aria-invalid={!!errors.tipoMidia}
																	value={field.value || 0}
																>
																	<MenuItem value="" sx={{color: appTema.palette.text.disabled}}><em>Selecione uma opção</em></MenuItem>
																	{
																		listOptionsTipoMidia.map((item:IOptions,keyItem) =>
																			<MenuItem value={item.value} key={keyItem}>{item.name}</MenuItem>
																		)
																	}
																</TextField>
															)}
														/>
												}
											</Grid>
											<Grid item xs={12}>
												{ seriesList.length > 0 &&
													<Controller
														name="idSerie"
														control={control}
														rules={{
															required: validacao.requerido,
														}}
														render={({ field }) => (
															<Autocomplete
																{...field}
																
																readOnly={(userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false} // Impede a edição manual
																id="series-autocomplete"
																fullWidth
																size="small"
																autoHighlight
																options={seriesList}
																getOptionLabel={(option) => `${option.titulo} (ID ${option.idSerie})`}
																value={seriesList.find((serie:any) => serie.idSerie === field.value) || null}
																onChange={(_, selectedOption) => {
																	const selectedValue:any = selectedOption ? selectedOption.idSerie : null;
																	field.onChange(selectedValue);
																}}
																renderOption={(props, option, { inputValue }) => {
																	const matches = match(option.titulo, inputValue, { insideWords: true });
																	const parts = parse(`${option.titulo} (ID ${option.idSerie})`, matches);
																	return (
																		<li {...props}>
																			<div>
																				{parts.map((part, index) => ( <span key={index} style={{ fontWeight: part.highlight ? 500 : "inherit" }}>{part.text}</span> ))}
																			</div>
																		</li>
																	);
																}}
																filterOptions={filterSeriesOptions}
																renderInput={(params) => (
																	<TextField
																		{...params}
																		label="Série (digite 2 caracteres) *"
																		variant="outlined"
																		helperText={errors.idSerie ? errors.idSerie.message : ''}
																		error={!!errors.idSerie}
																		aria-invalid={!!errors.idSerie}
																	/>
																)}
															/>
														)}
													/>
												}
											</Grid>
											<Grid item xs={12} sm={4}>
												<Controller
													name="numeroEpisodio"
													control={control}
													rules={{
														// required: validacao.requerido,
														minLength: { value:1, message:`${validacao.minLength} 1`, },
														maxLength: { value:8, message:`${validacao.maxLength} 8`, }
													}}
													render={({ field }) => (
														<TextField
															{...field}												
															label="Número do episódio"
															fullWidth
															size="small"
															inputProps={{
																maxLength:8,
																readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
															}}
															helperText={errors.numeroEpisodio ? errors.numeroEpisodio.message : null}
															error={!!errors.numeroEpisodio}
															aria-invalid={!!errors.numeroEpisodio}
							//								value={field.value || ''}
														/>
													)}
												/>
											</Grid>
											<Grid item xs={12} sm={4}>
												<Controller
													name="anoProducao"
													control={control}
													rules={{
														required: validacao.requerido,
														//minLength: { value:4, message:`${validacao.minLength} 4`, },
														//maxLength: { value:4, message:`${validacao.maxLength} 4`, },
														validate: {
															isWithinRange: (value) =>
															{
																const numericValue = parseInt(value, 10);
																if (numericValue >= 1900 && numericValue <= 2150) {
																	return true;
																} else {
																	return 'Deve ser >= 1900 e <= 2150';
																}
															},
														},
													}}
													render={({ field }) => (
														<TextField
															{...field}												
															label="Ano da produção (temporada) *"
															fullWidth
															size="small"
															type="number"
															inputProps={{
																maxLength:4,
																readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
															}}
															helperText={errors.anoProducao ? errors.anoProducao.message : ''}
															error={!!errors.anoProducao}
															aria-invalid={!!errors.anoProducao}
							//								value={field.value || ''}
														/>
													)}
												/>
											</Grid>
											<Grid item xs={12} sm={4}>
												<Controller
													name="anoLicenca"
													control={control}
													rules={{
														// required: validacao.requerido,
														minLength: { value:4, message:`${validacao.minLength} 4`, },
														maxLength: { value:4, message:`${validacao.maxLength} 4`, }
													}}
													render={({ field }) => (
														<TextField
															{...field}												
															label="Ano da 1ª licença"
															fullWidth
															size="small"
															type="text"
															inputProps={{
																maxLength:4,
																readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
															}}
															helperText={errors.anoLicenca ? errors.anoLicenca.message : ''}
															error={!!errors.anoLicenca}
															aria-invalid={!!errors.anoLicenca}
															value={field.value || ''}
														/>
													)}
												/>
											</Grid>
											<Grid item xs={12} sm={4}>
												<Controller
													name="duracao"
													control={control}
													rules={{
														// required: validacao.requerido,
														minLength: { value:8, message:`${validacao.minLength} 8`, },
														maxLength: { value:8, message:`${validacao.maxLength} 8`, },
														validate: { isFormatValid: (value) => {
															const pattern = /^\d{2}:\d{2}:\d{2}$/; // Expressão regular para o padrão "##:##:##"
															if (!pattern.test(value) && value === null && value === undefined) {
																return "Formato inválido"
															} else {
																return true
															}
														}}
													}}
													render={({ field }) => (
														<PatternFormat
															{...field}
															// disabled={(userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false}
															
															customInput={TextField}
															label="Duração"
															fullWidth
															size="small"
															inputProps={{
																maxLength:9,
																readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
															}}
															placeholder="00:00:00"
															format="##:##:##"
															//valueIsNumericString
															helperText={errors.duracao ? errors.duracao.message : null}
															error={!!errors.duracao}
															aria-invalid={!!errors.duracao}
															value={field.value || ''}
														/>
													)}
												/>
											</Grid>
											<Grid item xs={12} sm={4}>
												<Controller
													name="qtdBlocos"
													control={control}
													rules={{
														// required: validacao.requerido,
														// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
														maxLength: { value:20, message:`${validacao.maxLength} 20`, }
													}}
													render={({ field }) => (
														<TextField
															{...field}
															label="Número de blocos"
															fullWidth
															size="small"
															inputProps={{
																maxLength:8,
																readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
															}}
															helperText={errors.qtdBlocos ? errors.qtdBlocos.message : null}
															error={!!errors.qtdBlocos}
															aria-invalid={!!errors.qtdBlocos}
															value={field.value || ''}
														/>
													)}
												/>
											</Grid>
											<Grid item xs={12} sm={4}>
												{
													listOptionsClassEtaria &&
														<Controller
															name="classificacaoEtaria"
															control={control}
															rules={{
																// required: validacao.requerido,
															}}
															render={({ field }) => (
																<TextField
																	{...field}
																	SelectProps={{
																		readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
																	}}
																	label="Classificação etária"
																	select
																	fullWidth
																	size="small"
																	defaultValue={conteudoFormUpdate.classificacaoEtaria ? OptsController.nomeClassificacaoEtaria(conteudoFormUpdate.classificacaoEtaria) : ""}
																	helperText={errors.classificacaoEtaria ? errors.classificacaoEtaria.message : null}
																	error={!!errors.classificacaoEtaria}
																	aria-invalid={!!errors.classificacaoEtaria}
																>
																	<MenuItem value="" sx={{color: appTema.palette.text.disabled}}><em >Selecione uma opção</em></MenuItem>
																	{
																		listOptionsClassEtaria.map((item:IOptions,keyItem) =>
																			<MenuItem value={item.value} key={keyItem}>{item.name}</MenuItem>
																		)
																	}
																</TextField>
															)}
														/>
												}
											</Grid>
											<Grid item xs={12} sm={4}>
												<FormControl fullWidth size="small">
													<Controller
														name="possuiAudioME"
														control={control}
														render={({ field }) => (
															<StyledStack direction="row" spacing={1}>
																<InputLabel shrink>Possui áudio M/E?</InputLabel>
																<Typography className='semDestaque'>Não</Typography>
																<Switch
																	{...field}
																	disabled={(userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false}
																	
																	size='small'
																	defaultChecked={conteudoFormUpdate.possuiAudioME ? conteudoFormUpdate.possuiAudioME : false}
																/>
																<Typography>Sim</Typography>
															</StyledStack>
														)}
													/>
												</FormControl>
											</Grid>
											<Grid item xs={12} sm={4}>
												<FormControl fullWidth size="small">
													<Controller
														name="possuiClosedCaption"
														control={control}
														render={({ field }) => (
															<StyledStack direction="row" spacing={1}>
																<InputLabel shrink>Possui closed caption?</InputLabel>
																<Typography className='semDestaque'>Não</Typography>
																<Switch
																	{...field}
																	disabled={(userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false}
																	
																	size='small'
																	defaultChecked={conteudoFormUpdate.possuiClosedCaption ? conteudoFormUpdate.possuiClosedCaption : false}
																/>
																<Typography>Sim</Typography>
															</StyledStack>
														)}
													/>
												</FormControl>
											</Grid>
											<Grid item xs={12} sm={4}>
												<FormControl fullWidth size="small">
													<Controller
														name="aquisicao"
														control={control}
														render={({ field }) => (
															<StyledStack direction="row" spacing={1}>
																<InputLabel shrink>Aquisição?</InputLabel>
																<Typography className='semDestaque'>Não</Typography>
																<Switch
																	{...field}
																	disabled={(userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false}
																	
																	size='small'
																	defaultChecked={conteudoFormUpdate.aquisicao ? conteudoFormUpdate.aquisicao : false}
																/>
																<Typography>Sim</Typography>
															</StyledStack>
														)}
													/>
												</FormControl>
											</Grid>
											{ watch('aquisicao') &&
												<Grid item xs={12}>
													<Controller
														name="distribuidor"
														control={control}
														rules={{
															// required: validacao.requerido,
															// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
															maxLength: { value:100, message:`${validacao.maxLength} 100`, }
														}}
														render={({ field }) => (
															<TextField
																{...field}
																
																label={'Distribuidor'}
																fullWidth
																size="small"
																inputProps={{
																	maxLength:100,
																	readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
																}}
																helperText={errors.distribuidor ? errors.distribuidor.message : null}
																error={!!errors.distribuidor}
																aria-invalid={!!errors.distribuidor}
															/>
														)}
													/>
												</Grid>
											}
											<Grid item xs={12}>
												<Controller
													name="sinopse"
													control={control}
													rules={{
														// required: validacao.requerido,
														// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
														// maxLength: { value:100, message:`${validacao.maxLength} 100`, }
													}}
													render={({ field }) => (
														<TextField
															{...field}
															inputProps={{
																readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
															}}
															label="Sinopse"
															multiline
															minRows={2}
															maxRows={5}
															fullWidth
															size="small"
															helperText={errors.sinopse ? errors.sinopse.message : null}
															error={!!errors.sinopse}
															aria-invalid={!!errors.sinopse}
														/>
													)}
												/>
											</Grid>
											<Grid item xs={12} sm={operacao === EFORM.UPDATE ? 4 : 4}>
												<FormControl fullWidth size="small">
													<Controller
														name="aoVivo"
														control={control}
														render={({ field }) => (
															<StyledStack direction="row" spacing={1}>
																<InputLabel shrink>Ao vivo?</InputLabel>
																<Typography className='semDestaque'>Não</Typography>
																<Switch
																	{...field}
																	disabled={(userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false}
																	
																	size='small'
																	defaultChecked={conteudoFormUpdate.aoVivo ? conteudoFormUpdate.aoVivo : false}
																/>
																<Typography>Sim</Typography>
															</StyledStack>
														)}
													/>
												</FormControl>
											</Grid>
											<Grid item xs={12} sm={operacao === EFORM.UPDATE ? 4 : 4}>
												<LocalizationProvider dateAdapter={AdapterDayjs} localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}>
													<Controller
														name="dataExibicaoAoVivo"
														control={control}
														rules={{
															validate: value => isValidDate(value) || 'Deve ser >= 1900 e <= 2150',
														}}
														render={({ field }) => (
															<DatePicker
																{...field}
																	label="Data de exibição"
																	readOnly={(userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false} // Impede a edição manual
																	value={conteudoFormUpdate.dataExibicaoAoVivo ? dayjs.utc(conteudoFormUpdate.dataExibicaoAoVivo) as unknown as string : null}
																	slotProps={{
																		textField: {
																		size: 'small',
																		fullWidth: true,
																		helperText: errors.dataExibicaoAoVivo ? errors.dataExibicaoAoVivo.message : null,
																		error: !!errors.dataExibicaoAoVivo,
																		},
																	}}
																	maxDate={dayjs.utc('2151-01-01') as unknown as string}
																	format="DD-MM-YYYY"
																	disabled={!watch('aoVivo')}
																	onChange={(value) => {
																		const formattedDate = value ? dayjs(value).format('YYYY-MM-DD') : null;
																		setValue('dataExibicaoAoVivo', formattedDate);
																	}}
																	aria-invalid={!!errors.dataExibicaoAoVivo}
															/>
														)}
													/>
												</LocalizationProvider>
											</Grid>
											<Grid item xs={12}>
												<Controller
													name="palavraChave"
													control={control}
													rules={{
														// required: validacao.requerido,
														// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
														// maxLength: { value:100, message:`${validacao.maxLength} 100`, }
													}}
													render={({ field }) => (
														<TextField
															{...field}
															inputProps={{
																readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
															}}
															label={'Palavra-chave (separar por ;)'}
															multiline
															minRows={2}
															maxRows={5}
															fullWidth
															size="small"
															helperText={errors.palavraChave ? errors.palavraChave.message : null}
															error={!!errors.palavraChave}
															aria-invalid={!!errors.palavraChave}
														/>
													)}
												/>
											</Grid>
											{ operacao === EFORM.UPDATE && !isNull(conteudoFormUpdate.baseLimpa) ? (
												<Grid item xs={12} sm={6}>
													<FormControl fullWidth size="small">
														<Controller
															name="baseLimpa"
															control={control}
															render={({ field }) => (
																<StyledStack direction="row" spacing={1}>
																	<InputLabel shrink>Possui Base Limpa?</InputLabel>
																	<Typography className='semDestaque'>Não</Typography>
																	<Switch
																		{...field}
																		size='small'
																		disabled
																		defaultChecked={conteudoFormUpdate.baseLimpa ? conteudoFormUpdate.baseLimpa : false}
																	/>
																	<Typography className='semDestaque'>Sim</Typography>
																</StyledStack>
															)}
														/>
													</FormControl>
												</Grid>
											) : null}
											{ operacao === EFORM.UPDATE && !isNull(conteudoFormUpdate.ancineOficioDezembro2013) ? (
												<Grid item xs={12} sm={6}>
													<FormControl fullWidth size="small">
														<Controller
															name="ancineOficioDezembro2013"
															control={control}
															render={({ field }) => (
																<StyledStack direction="row" spacing={1}>
																	<InputLabel shrink>Ofício Ancine de Dezembro de 2013?</InputLabel>
																	<Typography className='semDestaque'>Não</Typography>
																	<Switch
																		{...field}
																		size='small'
																		disabled
																		defaultChecked={conteudoFormUpdate.ancineOficioDezembro2013 ? conteudoFormUpdate.ancineOficioDezembro2013 : false}
																	/>
																	<Typography className='semDestaque'>Sim</Typography>
																</StyledStack>
															)}
														/>
													</FormControl>
												</Grid>
											) : null}
											{ (operacao === EFORM.UPDATE && !isNull(conteudoFormUpdate.escaninho)) ? (
												<Grid item xs={12}>
													<Controller
														name="escaninho"
														control={control}
														rules={{
															// required: validacao.requerido,
															// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
															// maxLength: { value:100, message:`${validacao.maxLength} 100`, }
														}}
														render={({ field }) => (
															<TextField
																{...field}
																inputProps={{
																	readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
																}}
																label={'Escaninho'}													
																fullWidth
																size="small"
																helperText={errors.escaninho ? errors.escaninho.message : null}
																error={!!errors.escaninho}
																aria-invalid={!!errors.escaninho}
															/>
														)}
													/>
												</Grid>
											) : null}
										</Grid>
									</StyledAccordionDetails>
								</StyledAccordion>
							</Grid>
						{
						//#endregion
						//#region METADADOS da XDCAM
						}
							<Grid item xs={12}>
								<StyledAccordion expanded={expandedAccordion.indexOf('xdcam') >= 0 ? true : false } onChange={() => {handleAccordion('xdcam')}}>
									<StyledAccordionSummary aria-controls="xcam-content" id="xdcam-header">
										<Typography>Metadados da XDCAM</Typography>
									</StyledAccordionSummary>
									<StyledAccordionDetails>
										<Grid container spacing={2}>
											{
												(userRoleAdmin && !props.listViews) ? 
													<Grid item xs={12}>
														<Tooltip
															arrow
															placement="right"
															TransitionComponent={Zoom}
															TransitionProps={{ timeout: 500 }}
															title='Após a alteração de algum dos campos do grupo "Metadados da XDCAM", o programa deverá ser salvo para que o link de download seja atualizado. Caso o "Caminho no repositório" aponte para um diretório e não um arquivo, não será possível fazer o download.'>
															<IconButton color="primary"><EmojiObjectsOutlinedIcon/></IconButton>
														</Tooltip>
													</Grid> : ''
											}
											<Grid item xs={12} sm={6}>
												{/* <Controller
													name="idAcervoDigital"
													control={control}
													rules={{
														// required: validacao.requerido,
														// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
														maxLength: { value:20, message:`${validacao.maxLength} 20`, }
													}}
													render={({ field }) => (
														<TextField
															{...field}
															
															label="Repositório"
															fullWidth
															size="small"
															value={'acervodigital'}
															inputProps={{maxLength:20}}
															error={!!errors.idAcervoDigital}
															helperText={errors.idAcervoDigital ? errors.idAcervoDigital.message : null}
															aria-invalid={!!errors.idAcervoDigital}
														/>
													)}
												/> */}
												{ repositorioList &&
													<Controller
														name="idRepositorio"
														control={control}
														defaultValue={0}
														rules={{
															required: validacao.requerido,
														}}
														render={({ field }) => (
															<TextField
																{...field}
																SelectProps={{
																	readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual															
																}}
																label="Repositório"
																fullWidth
																size="small"
																select
																helperText={errors.idRepositorio ? errors.idRepositorio.message : null}
																error={!!errors.idRepositorio}
																aria-invalid={!!errors.idRepositorio}
																defaultValue={field.value || 0}
															>
																
																<MenuItem value={0} sx={{color: appTema.palette.text.disabled}}><em>Selecione uma opção</em></MenuItem>
																{
																	repositorioList.map((repositorio,keyRepositorio) =>
																		<MenuItem value={repositorio.idRepositorio} key={keyRepositorio}>{repositorio.nome}</MenuItem>
																	)
																}
															</TextField>
														)}
													/>
												}
											</Grid>
											<Grid item xs={12} sm={6}>
												<Controller
													name="idGsatIdFrm"
													control={control}
													rules={{
														required: validacao.requerido,
														// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
														maxLength: { value:20, message:`${validacao.maxLength} 20`, }
													}}
													render={({ field }) => (
														<TextField
															{...field}												
															label="ID GSAT/FRM"
															fullWidth
															size="small"
															inputProps={{
																maxLength:20,
																readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
															}}
															error={!!errors.idGsatIdFrm}
															helperText={errors.idGsatIdFrm ? errors.idGsatIdFrm.message : null}
															aria-invalid={!!errors.idGsatIdFrm}
														/>
													)}
												/>
											</Grid>
											{/*console.log(programaVideos)*/}
											{
												programaVideos.map((programas, indexProgramas) => (
													<Grid item xs={12} key={programas.id}>
														<Paper
															variant={isMenorLG ? 'outlined' : 'elevation'}
															elevation={isMenorLG ? 1 : 0} // 0 para desabilitar a elevação em resoluções menores que 'lg'
															sx={{ mb:2, padding:(isMenorLG ? 2 : 0) }}
														>
															<Grid container spacing={2} alignItems={"center"}>
																<Grid item xs={12} sm={programas.link ? 4 : 11} md={programas.link ? 5 : 11} lg={programas.link ? 6 : 11}>
																	<Controller
																		name={`programaVideos.${indexProgramas}.path`}
																		control={control}
																		render={({ field }) => (
																			<TextField
																				label="Caminho no repositório"
																				inputProps={{
																					readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
																				}}
																				fullWidth
																				value={field.value || ''}
																				onChange={field.onChange}
																				// onPaste={(e)=>handlePaste(e, indexProgramas)}
																				size="small"
																			/>
																		)}
																	/>
																</Grid>
																{
																	programas.link ?
																		<>
																			<Grid item xs={12} sm={2} md={2} lg={2}>
																				<Controller
																					name={`programaVideos.${indexProgramas}.size`}
																					control={control}
																					render={({ field }) => (
																						<TextField
																							label="Tamanho do arquivo"
																							fullWidth
																							value={field.value ? ((field.value / 1024) / 1024).toFixed(2) : ''}
																							onChange={field.onChange}
																							size="small"																				
																							InputProps={{
																								endAdornment: <InputAdornment position="end">MB</InputAdornment>,
																								readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
																							}}
																						/>
																					)}
																				/>
																			</Grid>
																			{
																				userRoleAdmin &&
																					<>
																						<Grid item xs={12} sm={5} md={4} lg={3} display={'flex'} flexDirection={'row'} flexWrap={'nowrap'}>
																							<Controller
																								name={`programaVideos.${indexProgramas}.link`}
																								control={control}
																								render={({ field }) => (
																									<>
																										<Button
																										href={field.value}
																										type="a"
																										variant="outlined"
																										color="primary"
																										size="medium"
																										target='_blank'
																										fullWidth
																										disabled={field.value && field.value != "" ? false : true}
																										sx={botaoIcone}>
																											<LaunchIcon/>
																										</Button>

																										<Button 
																										sx={botaoCopy}
																										variant={copied && copied === `copyButtonXDCAM_${indexProgramas.toString()}` ? "contained" : "outlined"}
																										color="primary"
																										size="medium"
																										fullWidth
																										onClick={() => {copyURL(field.value, 'copyButtonXDCAM', indexProgramas)}}>
																											{
																												copied && copied === `copyButtonXDCAM_${indexProgramas.toString()}` ?
																													<strong>Link Copiado</strong>
																												:
																													<strong>Copiar Link</strong>
																											}
																										</Button>
																									</>
																								)}
																							/> 
																						</Grid> 
																					</>
																				// : (programas.path && programas.path.indexOf('.mp4') > -1) ?
																				// 	<Grid item xs={12} sm={3} md={2} lg={2}>
																				// 		<Controller
																				// 			name={`programaVideos.${indexProgramas}.link`}
																				// 			control={control}
																				// 			render={({ field }) => (
																				// 				<Button
																				// 				href={field.value}
																				// 				type="a"
																				// 				variant="outlined"
																				// 				color="primary"
																				// 				size="medium"
																				// 				target='_blank'
																				// 				fullWidth
																				// 				disabled={field.value && field.value != "" ? false : true}
																				// 				sx={botaoIcone}>
																				// 					<LaunchIcon/>
																				// 				</Button>
																				// 			)}
																				// 		/> 
																				// 	</Grid> 
																				// : ''
																					
																			}
																		</> 
																	: ''
																}
																{
																	userRoleAdmin && !props.listViews ?
																		<Grid item xs={12} sm={programas.link ? 1 : 1} md={programas.link ? 1 : 1} lg={1}>
																			<Button
																				type="button"
																				variant="outlined"
																				color="error"
																				size="medium"
																				fullWidth
																				onClick={() => handleRemoveProgramaVideoItem(indexProgramas)}
																				title="Excluir item"
																				sx={botaoIconeDelete}>
																				<DeleteIcon/>
																			</Button>
																		</Grid> : ''
																}
															</Grid>
														</Paper>
													</Grid>
												))}
												{
													userRoleAdmin && !props.listViews ?
														<Grid item xs={12}>
															<Button
																startIcon={ <PlaylistAddIcon /> }
																variant="outlined"
																color="primary"
																title="Adicionar caminho para arquivo"
																onClick={() => handleAppendProgramaVideoItem()}>
																Adicionar caminho para arquivo
															</Button>
														</Grid> : ''
												}
										</Grid>
									</StyledAccordionDetails>
								</StyledAccordion>
							</Grid>
						{
						//#endregion
						//#region EXIBIÇÕES
						}
							<Grid item xs={12}>
								<StyledAccordion expanded={expandedAccordion.indexOf('exibicoes') >= 0 ? true : false } onChange={() => {handleAccordion('exibicoes')}}>
									<StyledAccordionSummary aria-controls="exibicoes-content" id="exibicoes-header">
										<Typography>Exibições</Typography>
									</StyledAccordionSummary>
									<StyledAccordionDetails>
										<Grid container spacing={2}>
											<Grid item xs={12} sm={4}>
												<LocalizationProvider dateAdapter={AdapterDayjs} localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}>
													<Controller
															name="dataExibicao"
															control={control}
															rules={{
																validate: value => isValidDate(value) || 'Deve ser >= 1900 e <= 2150'
															}}
															render={({ field }) => (
																<DatePicker
																	{...field}
																		readOnly={(userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false} // Impede a edição manual
																		label="Data de exibição"
																		value={conteudoFormUpdate.dataExibicao ? dayjs.utc(conteudoFormUpdate.dataExibicao) as unknown as string : null}
																		slotProps={{
																			textField: {
																			size: 'small',
																			fullWidth: true,
																			helperText: errors.dataExibicao ? errors.dataExibicao.message : null,
																			error: !!errors.dataExibicao,
																			},
																		}}
																		maxDate={dayjs.utc('2151-01-01') as unknown as string}
																		format="DD-MM-YYYY"
																		onChange={(value) => {
																			const formattedDate = value ? dayjs(value).format('YYYY-MM-DD') : null;
																			setValue('dataExibicao', formattedDate);
																		}}
																		aria-invalid={!!errors.dataExibicao}
																/>
															)}
														/>
												</LocalizationProvider>
											</Grid>
											<Grid item xs={12} sm={4}>
												{
													listOptionsVigencia &&
														<Controller
															name="vigencia"
															control={control}
															rules={{
																// required: validacao.requerido,
															}}
															render={({ field }) => (
																<TextField
																	{...field}
																	SelectProps={{
																		readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
																	}}
																	label="Vigência"
																	select
																	fullWidth
																	size="small"
																	helperText={errors.vigencia ? errors.vigencia.message : null}
																	error={!!errors.vigencia}
																	aria-invalid={!!errors.vigencia}
																	value={field.value || 0}
																>
																	<MenuItem value={0} sx={{color: appTema.palette.text.disabled}}><em>Selecione uma opção</em></MenuItem>
																	{
																		listOptionsVigencia.map((item:IOptions,keyItem) =>
																			<MenuItem value={item.value} key={keyItem}>{item.name}</MenuItem>
																		)
																	}
																</TextField>
															)}
														/>
												}
											</Grid>
											<Grid item xs={12} sm={4}>
												<Controller
													name="qtdExibicoes"
													control={control}
													rules={{
														// required: validacao.requerido,
														//minLength: { value:1, message:`${validacao.minLength} 1`, },
														//maxLength: { value:5, message:`${validacao.maxLength} 5`, },
														validate: {
															isWithinRange: (value) =>
															{
																if (value === null || value === undefined || (value >= 1 && value <= 99999))
																{
																	return true;
																} else {
																	return 'Deve ser >= 1 e <= 99.999';
																}
															},
														},
													}}
													render={({ field }) => (
														<TextField
															{...field}
															label="Exibições"
															fullWidth
															size="small"
															type="number"
															inputProps={{
																maxLength:5,
																readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
															}}
															helperText={errors.qtdExibicoes ? errors.qtdExibicoes.message : null}
															error={!!errors.qtdExibicoes}
															aria-invalid={!!errors.qtdExibicoes}
															value={field.value || ''}
															onChange={field.onChange}
														/>
													)}
												/>
											</Grid>
											<Grid item xs={12} sm={4}>
												<LocalizationProvider dateAdapter={AdapterDayjs} localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}>
													<Controller
														name="prazo"
														control={control}
														rules={{
															validate: value => isValidDate(value) || 'Deve ser >= 1900 e <= 2150'
														}}
														render={({ field }) => (
															<DatePicker
																{...field}
																	readOnly={(userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false} // Impede a edição manual
																	label="Prazo"
																	value={conteudoFormUpdate.prazo ? dayjs.utc(conteudoFormUpdate.prazo) as unknown as string : null}
																	slotProps={{
																		textField: {
																		size: 'small',
																		fullWidth: true,
																		helperText: errors.prazo ? errors.prazo.message : null,
																		error: !!errors.prazo,
																		},
																	}}
																	maxDate={dayjs.utc('2151-01-01') as unknown as string}
																	format="DD-MM-YYYY"
																	onChange={(value) => {
																		const formattedDate = value ? dayjs(value).format('YYYY-MM-DD') : null;
																		setValue('prazo', formattedDate);
																	}}
																	aria-invalid={!!errors.prazo}
															/>
														)}
													/>
												</LocalizationProvider>
											</Grid>
											<Grid item xs={12} sm={4}>
												<LocalizationProvider dateAdapter={AdapterDayjs} localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}>
													<Controller
														name="dataVencimento"
														control={control}
														rules={{
															validate: value => isValidDate(value) || 'Deve ser >= 1900 e <= 2150'
														}}
														render={({ field }) => (
															<DatePicker
																{...field}
																	readOnly={(userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false} // Impede a edição manual
																	label="Data do alerta (automática)"
																	value={conteudoFormUpdate.dataVencimento ? dayjs.utc(conteudoFormUpdate.dataVencimento) as unknown as string : null}
																	slotProps={{
																		textField: {
																		size: 'small',
																		fullWidth: true,
																		helperText: errors.dataVencimento ? errors.dataVencimento.message : null,
																		error: !!errors.dataVencimento,
																		},
																	}}
																	maxDate={dayjs.utc('2151-01-01') as unknown as string}
																	format="DD-MM-YYYY"
																	onChange={(value) => {
																		const formattedDate = value ? dayjs(value).format('YYYY-MM-DD') : null;
																		setValue('dataVencimento', formattedDate);
																	}}
																	aria-invalid={!!errors.dataVencimento}
															/>
														)}
													/>
												</LocalizationProvider>
											</Grid>
											<Grid item xs={12}>
												<Controller
													name="restricaoExibicao"
													control={control}
													rules={{
														// required: validacao.requerido,
														// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
														// maxLength: { value:100, message:`${validacao.maxLength} 100`, }
													}}
													render={({ field }) => (
														<TextField
															{...field}
															inputProps={{
																readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
															}}
															label={'Restrição'}
															multiline
															minRows={2}
															maxRows={5}
															fullWidth
															size="small"
															helperText={errors.restricaoExibicao ? errors.restricaoExibicao.message : null}
															error={!!errors.restricaoExibicao}
															aria-invalid={!!errors.restricaoExibicao}
														/>
													)}
												/>
											</Grid>
										</Grid>
									</StyledAccordionDetails>
								</StyledAccordion>
							</Grid>
						{
						//#endregion
						//#region FICHA TÉCNICA
						}
							<Grid item xs={12}>
								<StyledAccordion expanded={expandedAccordion.indexOf('fichatecnica') >= 0 ? true : false } onChange={() => {handleAccordion('fichatecnica')}}>
									<StyledAccordionSummary aria-controls="fichatecnica-content" id="fichatecnica-header">
										<Typography>Ficha técnica</Typography>
									</StyledAccordionSummary>
									<StyledAccordionDetails>
										<Grid container spacing={2}>
											<Grid item xs={12}>
												<Controller
													name="listaMusica"
													control={control}
													rules={{
														// required: validacao.requerido,
														// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
														// maxLength: { value:100, message:`${validacao.maxLength} 100`, }
													}}
													render={({ field }) => (
														<TextField
															{...field}
															inputProps={{
																readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
															}}
															label={'Lista de música (separar por ;)'}
															multiline
															minRows={2}
															maxRows={5}
															fullWidth
															size="small"
															helperText={errors.listaMusica ? errors.listaMusica.message : null}
															error={!!errors.listaMusica}
															aria-invalid={!!errors.listaMusica}
														/>
													)}
												/>
											</Grid>
											<Grid item xs={12}>
												<Controller
													name="consultoria"
													control={control}
													rules={{
														// required: validacao.requerido,
														// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
														maxLength: { value:100, message:`${validacao.maxLength} 100`, }
													}}
													render={({ field }) => (
														<TextField
															{...field}
															label="Consultoria (separar por ;)"
															fullWidth
															size="small"
															inputProps={{
																maxLength:100,
																readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
															}}
															helperText={errors.consultoria ? errors.consultoria.message : null}
															error={!!errors.consultoria}
															aria-invalid={!!errors.consultoria}
														/>
													)}
												/>
											</Grid>
											<Grid item xs={12}>
												{
													listOptionsLicenciamento &&
														<Controller
															name="licenciamento"
															control={control}
															rules={{
																// required: validacao.requerido,
															}}
															render={({ field }) => (
																<TextField
																	{...field}
																	SelectProps={{
																		readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
																	}}
																	select
																	label="Licenciamento"
																	fullWidth
																	size="small"
																	helperText={errors.licenciamento ? errors.licenciamento.message : null}
																	error={!!errors.licenciamento}
																	aria-invalid={!!errors.licenciamento}
																	defaultValue={field.value || 0}
																>
																	<MenuItem value={0} sx={{color: appTema.palette.text.disabled}}><em>Selecione uma opção</em></MenuItem>
																	{
																		listOptionsLicenciamento.map((item:IOptions,keyItem) =>
																			<MenuItem value={item.value} key={keyItem}>{item.name}</MenuItem>
																		)
																	}
																</TextField>
															)}
														/>
												}
											</Grid>
											<Grid item xs={12}>
												<Controller
													name="restricoes"
													control={control}
													rules={{
														// required: validacao.requerido,
														// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
														// maxLength: { value:100, message:`${validacao.maxLength} 100`, }
													}}
													render={({ field }) => (
														<TextField
															{...field}
															inputProps={{
																readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
															}}
															label={'Restrições'}
															multiline
															minRows={2}
															maxRows={5}
															fullWidth
															size="small"
															helperText={errors.restricoes ? errors.restricoes.message : null}
															error={!!errors.restricoes}
															aria-invalid={!!errors.restricoes}
														/>
													)}
												/>
											</Grid>
											{ watch('tipoPrograma') === 2 &&
												<>
													<Grid item xs={12}>
														<Controller
															name="apresentador"
															control={control}
															rules={{
																// required: validacao.requerido,
																// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
																// maxLength: { value:100, message:`${validacao.maxLength} 100`, }
															}}
															render={({ field }) => (
																<TextField
																	{...field}
																	inputProps={{
																		readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
																	}}
																	label={'Apresentador (separar por ;)'}
																	multiline
																	minRows={2}
																	maxRows={5}
																	fullWidth
																	size="small"
																	helperText={errors.apresentador ? errors.apresentador.message : null}
																	error={!!errors.apresentador}
																	aria-invalid={!!errors.apresentador}
																/>
															)}
														/>
													</Grid>
													<Grid item xs={12}>
														<Controller
															name="direcao"
															control={control}
															rules={{
																// required: validacao.requerido,
																// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
																maxLength: { value:100, message:`${validacao.maxLength} 100`, }
															}}
															render={({ field }) => (
																<TextField
																	{...field}
																	label="Direção (separar por ;)"
																	fullWidth
																	size="small"
																	inputProps={{
																		maxLength:100,
																		readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
																	}}
																	helperText={errors.direcao ? errors.direcao.message : null}
																	error={!!errors.direcao}
																	aria-invalid={!!errors.direcao}
																/>
															)}
														/>
													</Grid>
													<Grid item xs={12}>
														<Controller
															name="edicao"
															control={control}
															rules={{
																// required: validacao.requerido,
																// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
																maxLength: { value:100, message:`${validacao.maxLength} 100`, }
															}}
															render={({ field }) => (
																<TextField
																	{...field}
																	label="Edição (separar por ;)"
																	fullWidth
																	size="small"
																	inputProps={{
																		maxLength:100,
																		readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
																	}}
																	helperText={errors.edicao ? errors.edicao.message : null}
																	error={!!errors.edicao}
																	aria-invalid={!!errors.edicao}
																/>
															)}
														/>
													</Grid>
													<Grid item xs={12}>
														<Controller
															name="entrevistado"
															control={control}
															rules={{
																// required: validacao.requerido,
																// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
																maxLength: { value:100, message:`${validacao.maxLength} 100`, }
															}}
															render={({ field }) => (
																<TextField
																	{...field}
																	label="Entrevistado (separar por ;)"
																	fullWidth
																	size="small"
																	inputProps={{
																		maxLength:100,
																		readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
																	}}
																	helperText={errors.entrevistado ? errors.entrevistado.message : null}
																	error={!!errors.entrevistado}
																	aria-invalid={!!errors.entrevistado}
																/>
															)}
														/>
													</Grid>
													<Grid item xs={12}>
														<Controller
															name="elenco"
															control={control}
															rules={{
																// required: validacao.requerido,
																// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
																// maxLength: { value:100, message:`${validacao.maxLength} 100`, }
															}}
															render={({ field }) => (
																<TextField
																	{...field}
																	inputProps={{
																		readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
																	}}
																	label={'Elenco (separar por ;)'}
																	multiline
																	minRows={2}
																	maxRows={5}
																	fullWidth
																	size="small"
																	helperText={errors.elenco ? errors.elenco.message : null}
																	error={!!errors.elenco}
																	aria-invalid={!!errors.elenco}
																/>
															)}
														/>
													</Grid>
													<Grid item xs={12}>
														<Controller
															name="fotografia"
															control={control}
															rules={{
																// required: validacao.requerido,
																// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
																maxLength: { value:100, message:`${validacao.maxLength} 100`, }
															}}
															render={({ field }) => (
																<TextField
																	{...field}
																	label="Fotografia (separar por ;)"
																	fullWidth
																	size="small"
																	inputProps={{
																		maxLength:100,
																		readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
																	}}
																	helperText={errors.fotografia ? errors.fotografia.message : null}
																	error={!!errors.fotografia}
																	aria-invalid={!!errors.fotografia}
																/>
															)}
														/>
													</Grid>
													<Grid item xs={12}>
														<Controller
															name="narrador"
															control={control}
															rules={{
																// required: validacao.requerido,
																// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
																maxLength: { value:100, message:`${validacao.maxLength} 100`, }
															}}
															render={({ field }) => (
																<TextField
																	{...field}
																	label="Narrador (separar por ;)"
																	fullWidth
																	size="small"
																	inputProps={{
																		maxLength:100,
																		readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
																	}}
																	helperText={errors.narrador ? errors.narrador.message : null}
																	error={!!errors.narrador}
																	aria-invalid={!!errors.narrador}
																/>
															)}
														/>
													</Grid>
													<Grid item xs={12}>
														<Controller
															name="producao"
															control={control}
															rules={{
																// required: validacao.requerido,
																// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
																maxLength: { value:100, message:`${validacao.maxLength} 100`, }
															}}
															render={({ field }) => (
																<TextField
																	{...field}
																	label="Produção (separar por ;)"
																	fullWidth
																	size="small"
																	inputProps={{
																		maxLength:100,
																		readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
																	}}
																	helperText={errors.producao ? errors.producao.message : null}
																	error={!!errors.producao}
																	aria-invalid={!!errors.producao}
																/>
															)}
														/>
													</Grid>
													<Grid item xs={12}>
														<Controller
															name="roteiro"
															control={control}
															rules={{
																// required: validacao.requerido,
																// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
																maxLength: { value:100, message:`${validacao.maxLength} 100`, }
															}}
															render={({ field }) => (
																<TextField
																	{...field}
																	label="Roteiro"
																	fullWidth
																	size="small"
																	inputProps={{
																		maxLength:100,
																		readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
																	}}
																	helperText={errors.roteiro ? errors.roteiro.message : null}
																	error={!!errors.roteiro}
																	aria-invalid={!!errors.roteiro}
																/>
															)}
														/>
													</Grid>
													<Grid item xs={12}>
														<Controller
															name="trilhaOriginal"
															control={control}
															rules={{
																// required: validacao.requerido,
																// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
																maxLength: { value:100, message:`${validacao.maxLength} 100`, }
															}}
															render={({ field }) => (
																<TextField
																	{...field}
																	label="Trilha original (autor) (separar por ;)"
																	fullWidth
																	size="small"
																	inputProps={{
																		maxLength:100,
																		readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
																	}}
																	helperText={errors.trilhaOriginal ? errors.trilhaOriginal.message : null}
																	error={!!errors.trilhaOriginal}
																	aria-invalid={!!errors.trilhaOriginal}
																/>
															)}
														/>
													</Grid>
												</>
											}
											<Grid item xs={12}>
												<Card variant="outlined" sx={{pt:1, pb:0}}>
													{/* <CardHeader title="Timecodes"></CardHeader> */}
													<CardContent sx={{px:2, py:0}}>
														<Grid container>
															<Grid item xs={12}>
																<Box display={"flex"} alignItems={"center"}>
																	<Typography sx={(userRoleAdmin && !props.listViews) ? {} : {mb:2}}>Timecodes:</Typography>
																	{
																		(userRoleAdmin && !props.listViews) ? 
																			<Tooltip
																				arrow
																				placement="right"
																				TransitionComponent={Zoom}
																				TransitionProps={{ timeout: 500 }}
																				title="Timecodes podem ser importados em lote. Para isso, basta copiar (ctrl+C) os timecodes,
																					com um timecode por linha, com campos separados por '#'.
																					Após isso, basta clicar no botão 'ADICIONAR TIMECODE', em seguida selecionar o campo 'Versão',
																					e colar (ctrl+V) os timecodes previamente copiados.
																					Os timecodes serão inseridos na mesma sequência que foram copiados.">
																				<IconButton color="primary"><EmojiObjectsOutlinedIcon/></IconButton>
																			</Tooltip> : ''
																	}
																</Box>
															</Grid>
															{
																(userRoleAdmin && !props.listViews) ?
																	programaTimecodes.map((field, index) => (
																		
																		<Grid item xs={12} key={field.id}>
																			<Paper
																				variant={isMenorLG ? 'outlined' : 'elevation'}
																				elevation={isMenorLG ? 1 : 0} // 0 para desabilitar a elevação em resoluções menores que 'lg'
																				sx={{ mb:2, padding:(isMenorLG ? 2 : 0) }}
																			>
																				<Grid container spacing={1} alignItems={"center"}>
																					<Grid item xs={12} sm={3} lg={1}>
																						<Controller
																							name={`programaTimecodes.${index}.versao`}
																							control={control}
																							render={({ field }) => (
																								<TextField
																									label="Versão"
																									fullWidth
																									value={field.value || ''}
																									onChange={field.onChange}
																									onPaste={(e)=>handlePaste(e, index)}
																									size="small"
																									inputProps={{
																										readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
																									}}
																									// sx={styletimecodesInputs}
																								/>
																							)}
																						/>
																					</Grid>
																					<Grid item xs={12} sm={3} lg={2}>
																						<LocalizationProvider dateAdapter={AdapterDayjs} localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}>
																							<Controller
																								name={`programaTimecodes.${index}.dataHora`}
																								control={control}
																								render={({ field }) => (
																									<DateTimePicker
																										{...field}
																										readOnly={(userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false}
																										// value={dayjs.utc(props.formDefaultValues.dataAlerta ? props.formDefaultValues.dataAlerta : dayjs(new Date())) as unknown as string}
																										value={ field.value ? dayjs.utc(field.value ? field.value : '') as unknown as string : null }
																										label="Data"
																										ampm={false}
																										// defaultValue={field.value ? dayjs.utc(field.value ? field.value : '') as unknown as string : null}
																										timezone="America/Sao_Paulo"
																										format="DD-MM-YYYY H:mm"
																										slotProps={{ textField: { size: 'small', fullWidth: true } }}
																										// sx={styletimecodesInputs}
																										onChange={(value) => { setValue(`programaTimecodes.${index}.dataHora`, value); }}
																									/>
																								)}
																							/>
																						</LocalizationProvider>
																					</Grid>
																					<Grid item xs={12} sm={3} lg={1}>
																						<Controller
																							name={`programaTimecodes.${index}.timecode`}
																							control={control}
																							render={({ field }) => (
																								<TextField
																									label="Duração"
																									inputProps={{
																										readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
																									}}
																									fullWidth
																									value={field.value || ''}
																									onChange={field.onChange}
																									size="small"
																								/>
																							)}
																						/>
																					</Grid>
																					<Grid item xs={12} sm={3} lg={2}>
																						<Controller
																							name={`programaTimecodes.${index}.resposta`}
																							control={control}
																							render={({ field }) => (
																								<TextField
																									label="Resposta"
																									inputProps={{
																										readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
																									}}
																									fullWidth
																									value={field.value || ''}
																									onChange={field.onChange}
																									size="small"
																								/>
																							)}
																						/>
																					</Grid>
																					<Grid item xs={12} sm={6} lg={2}>
																						<Controller
																							name={`programaTimecodes.${index}.texto`}
																							control={control}
																							defaultValue=""
																							render={({ field }) => (
																								<TextField
																									label="Texto"
																									inputProps={{
																										readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
																									}}
																									fullWidth
																									value={field.value || ''}
																									onChange={field.onChange}
																									size="small"
																								/>
																							)}
																						/>
																					</Grid>
																					<Grid item xs={12} sm={3} lg={2}>
																						<Controller
																							name={`programaTimecodes.${index}.autor`}
																							control={control}
																							render={({ field }) => (
																								<TextField
																									label="Autor"
																									inputProps={{
																										readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
																									}}
																									fullWidth
																									value={field.value || ''}
																									onChange={field.onChange}
																									size="small"
																								/>
																							)}
																						/>
																					</Grid>
																					<Grid item xs={12} sm={3} lg={1}>
																						<Controller
																							name={`programaTimecodes.${index}.status`}
																							control={control}
																							render={({ field }) => (
																								<TextField
																									label="Status"
																									inputProps={{
																										readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
																									}}
																									fullWidth
																									value={field.value || ''}
																									onChange={field.onChange}
																									size="small"
																								/>
																							)}
																						/>
																					</Grid>
																					{
																						userRoleAdmin && !props.listViews ? 
																							<Grid item xs={12} sm={12} lg={1}>
																								<Button
																									type="button"
																									variant="outlined"
																									color="error"
																									size="medium"
																									fullWidth
																									onClick={() => handleRemoveTimecodeItem(index)}
																									title="Excluir item"
																									sx={botaoIcone}>
																									<DeleteIcon/>
																								</Button>
																							</Grid> : ''
																					}
																				</Grid>
																			</Paper>
																		</Grid>
																		
																	)) :
																	programaTimecodes.map((field, index) => <> 
																		<Grid item xs={12} key={field.id}>
																			<TimecodeView
																				versao={field.versao}
																				dataHora={field.dataHora}
																				duracao={field.timecode}																	
																				resposta={field.resposta}
																				texto={field.texto}
																				autor={field.autor}
																				status={field.status}
																				idProgramaTimecode={field.id}																		
																				isMenorLGView={isMenorLG}
																				ind={index}	
																				Ccontrol={control}																	
																			/>
																		</Grid>
																	</>)
															}
														</Grid>
														{
															userRoleAdmin && !props.listViews ?
																<Button
																	startIcon={ <PlaylistAddIcon /> }
																	variant="outlined"
																	color="primary"
																	title="Adicionar timecode"
																	onClick={() => handleAppendTimecodeItem()}>
																	Adicionar Timecode
																</Button> : ''
														}
													</CardContent>
													{/* <CardActions></CardActions> */}
												</Card>
											</Grid>
										</Grid>
									</StyledAccordionDetails>
								</StyledAccordion>
							</Grid>
						{
						//#endregion
						//#region METADADOS DO ROTEIRO
						}
							<Grid item xs={12}>
								<StyledAccordion expanded={expandedAccordion.indexOf('roteiro') >= 0 ? true : false } onChange={() => {handleAccordion('roteiro')}}>
									<StyledAccordionSummary aria-controls="roteiro-content" id="roteiro-header">
										<Typography>Metadados do roteiro</Typography>
									</StyledAccordionSummary>
									<StyledAccordionDetails>
										<Grid container spacing={2}>
											<Grid item xs={12}>
												<Controller
													name="autor"
													control={control}
													rules={{
														// required: validacao.requerido,
														// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
														maxLength: { value:100, message:`${validacao.maxLength} 100`, }
													}}
													render={({ field }) => (
														<TextField
															{...field}
															label="Autor (separar por ;)"
															fullWidth
															size="small"
															inputProps={{
																maxLength:100,
																readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
															}}
															helperText={errors.autor ? errors.autor.message : null}
															error={!!errors.autor}
															aria-invalid={!!errors.autor}
														/>
													)}
												/>
											</Grid>
											<Grid item xs={12}>
												<Controller
													name="consultoriaRoteiro"
													control={control}
													rules={{
														// required: validacao.requerido,
														// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
														maxLength: { value:100, message:`${validacao.maxLength} 100`, }
													}}
													render={({ field }) => (
														<TextField
															{...field}
															label="Consultoria (separar por ;)"
															fullWidth
															size="small"
															inputProps={{
																maxLength:100,
																readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
															}}
															helperText={errors.consultoriaRoteiro ? errors.consultoriaRoteiro.message : null}
															error={!!errors.consultoriaRoteiro}
															aria-invalid={!!errors.consultoriaRoteiro}
														/>
													)}
												/>
											</Grid>
										</Grid>
									</StyledAccordionDetails>
								</StyledAccordion>
							</Grid>
						{
						//#endregion
						//#region OBSERVAÇÕES GERAIS
						}
							<Grid item xs={12}>
								<StyledAccordion expanded={expandedAccordion.indexOf('observacoes') >= 0 ? true : false } onChange={() => {handleAccordion('observacoes')}}>
									<StyledAccordionSummary aria-controls="observacoes-content" id="observacoes-header">
										<Typography>Observações gerais</Typography>
									</StyledAccordionSummary>
									<StyledAccordionDetails>
										<Grid container spacing={2}>
											<Grid item xs={12}>
												<Controller
													name="observacoesGerais"
													control={control}
													rules={{
														// required: validacao.requerido,
														// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
														// maxLength: { value:100, message:`${validacao.maxLength} 100`, }
													}}
													render={({ field }) => (
														<TextField
															{...field}
															inputProps={{
																readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
															}}
															label={'Observações gerais'}
															multiline
															minRows={2}
															maxRows={5}
															fullWidth
															size="small"
															helperText={errors.observacoesGerais ? errors.observacoesGerais.message : null}
															error={!!errors.observacoesGerais}
															aria-invalid={!!errors.observacoesGerais}
														/>
													)}
												/>
											</Grid>
										</Grid>
									</StyledAccordionDetails>
								</StyledAccordion>
							</Grid>
						{
						//#endregion
						//#region VERSÃO
						}
							<Grid item xs={12}>
								<StyledAccordion expanded={expandedAccordion.indexOf('versao') >= 0 ? true : false } onChange={() => {handleAccordion('versao')}}>
									<StyledAccordionSummary aria-controls="versao-content" id="versao-header">
										<Typography>Versão</Typography>
									</StyledAccordionSummary>
									<StyledAccordionDetails>
										<Grid container spacing={2}>
										<Grid item xs={12}>
												<Controller
													name="tituloOriginalPrograma"
													control={control}
													rules={{
														// required: validacao.requerido,
														// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
														maxLength: { value:200, message:`${validacao.maxLength} 200`, }
													}}
													render={({ field }) => (
														<TextField
															{...field}
															label={'Título Original do Programa'}
															fullWidth
															size="small"
															inputProps={{
																maxLength:200,
																readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
															}}
															helperText={errors.tituloOriginalPrograma ? errors.tituloOriginalPrograma.message : null}
															error={!!errors.tituloOriginalPrograma}
															aria-invalid={!!errors.tituloOriginalPrograma}
														/>
													)}
												/>
											</Grid>
											<Grid item xs={12}>
												<Controller
													name="tituloOriginalSerie"
													control={control}
													rules={{
														// required: validacao.requerido,
														// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
														maxLength: { value:200, message:`${validacao.maxLength} 200`, }
													}}
													render={({ field }) => (
														<TextField
															{...field}
															label={'Título Original da Série'}
															fullWidth
															size="small"
															inputProps={{
																maxLength:200,
																readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
															}}
															helperText={errors.tituloOriginalSerie ? errors.tituloOriginalSerie.message : null}
															error={!!errors.tituloOriginalSerie}
															aria-invalid={!!errors.tituloOriginalSerie}
														/>
													)}
												/>
											</Grid>								
											<Grid item xs={12} sm={6}>
												{
													listOptionsVersao &&
														<Controller
															name="versao"
															control={control}
															render={({ field }) => (
																<TextField
																	{...field}
																	SelectProps={{
																		readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
																	}}
																	label="Versão"
																	select
																	fullWidth
																	size="small"
																	value={field.value}
																	helperText={errors.versao ? errors.versao.message : null}
																	error={!!errors.versao}
																	aria-invalid={!!errors.versao}
																	defaultValue={field.value || 0}
																>
																	<MenuItem value={0} sx={{color: appTema.palette.text.disabled}}><em>Selecione uma opção</em></MenuItem>
																	{
																		listOptionsVersao.map((item:IOptions,keyItem) =>
																			<MenuItem value={item.value} key={keyItem}>{item.name}</MenuItem>
																		)
																	}
																</TextField>
															)}
														/>
												}
											</Grid>
											<Grid item xs={12} sm={6}>
												{
													listOptionsIdioma &&
														<Controller
															name="idiomaVersao"
															control={control}
															rules={{
																// required: validacao.requerido,
																// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
																// maxLength: { value:100, message:`${validacao.maxLength} 100`, }
															}}
															render={({ field }) => (
																<TextField
																	{...field}
																	SelectProps={{
																		readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
																	}}
																	label="Idioma da versão"
																	select
																	fullWidth
																	size="small"
																	value={field.value}
																	helperText={errors.idiomaVersao ? errors.idiomaVersao.message : null}
																	error={!!errors.idiomaVersao}
																	aria-invalid={!!errors.idiomaVersao}
																	defaultValue={field.value || 0}
																>
																	<MenuItem value={0} sx={{color: appTema.palette.text.disabled}}><em>Selecione uma opção</em></MenuItem>
																	{
																		listOptionsIdioma.map((item:IOptions,keyItem) =>
																			<MenuItem value={item.value} key={keyItem}>{item.name}</MenuItem>
																		)
																	}
																</TextField>
															)}
														/>
												}
											</Grid>
											<Grid item xs={12}>
												<Controller
													name="sinopseIdioma"
													control={control}
													rules={{
														// required: validacao.requerido,
														// minLength: { value:TROQUE, message:`${validacao.minLength} TROQUE`, },
														// maxLength: { value:100, message:`${validacao.maxLength} 100`, }
													}}
													render={({ field }) => (
														<TextField
															{...field}
															inputProps={{
																readOnly: (userRoleAdmin && props.listViews) || !userRoleAdmin ? true : false, // Impede a edição manual
															}}
															label={'Sinopse em outro idioma'}
															multiline
															minRows={2}
															maxRows={5}
															fullWidth
															size="small"
															helperText={errors.sinopseIdioma ? errors.sinopseIdioma.message : null}
															error={!!errors.sinopseIdioma}
															aria-invalid={!!errors.sinopseIdioma}
														/>
													)}
												/>
											</Grid>
										</Grid>
									</StyledAccordionDetails>
								</StyledAccordion>
							</Grid>
						{
						//#endregion
						}
					</CustomTabPanel>
					{
						EFORM.UPDATE &&
							<CustomTabPanel value={tabItem} index={1}>
								{
								//#region ANEXOS				
								}
								{
									<Grid item xs={12}>	
										<StyledAccordion expanded={expandedAccordion.indexOf('anexos') >= 0 ? true : false } onChange={() => {handleAccordion('anexos')}}>
											<StyledAccordionSummary aria-controls="anexos-content" id="anexos-header">
												<Typography>Anexos</Typography>
											</StyledAccordionSummary>
											<StyledAccordionDetails>
												<Grid container spacing={2}>
													<Grid item xs={12}>
													{/*console.log(programaAnexos)*/}
														<Grid container>
															{
																programaAnexos
																.filter((fieldAnexos) => fieldAnexos.nome !== "invalid" && fieldAnexos.tipo == TipoAnexo.ANEXO)
																.map((fieldAnexos) => 
																{
																  
																const originalIndex = programaAnexos.findIndex(item => item.id === fieldAnexos.id);
															  
																  return (
																	<React.Fragment key={fieldAnexos.id}>
																		{
																			(fieldAnexos.nome != "invalid" && fieldAnexos.tipo == TipoAnexo.ANEXO) &&
																				<Grid item xs={12}>
																					<Paper
																						variant={isMenorSM ? 'outlined' : 'elevation'}
																						elevation={isMenorSM ? 1 : 0} // 0 para desabilitar a elevação em resoluções menores que 'sm'
																						sx={{ mb:2, padding:(isMenorSM ? 2 : 0) }}
																					>
																						<Grid container spacing={1} alignItems={"center"}>
																							<Grid item xs={12} sm={10} lg={11} sx={gridAnexos}>
																									
																								<Controller
																									name={`programaAnexos.${originalIndex}.nome`}
																									control={control}
																									render={({ field }) => (
																										<Button
																											id={`programaAnexos.${originalIndex}.nome`}
																											size="medium"
																											variant="text"
																											data-type="buttonLink"
																											href={userRoleAdmin && fieldAnexos.link ? fieldAnexos.link : undefined}
																											endIcon={userRoleAdmin && fieldAnexos.link ? <OpenInNewOutlinedIcon/> : undefined}
																											target={userRoleAdmin && fieldAnexos.link ? '_blank' : undefined}
																											color={userRoleAdmin && fieldAnexos.link ? undefined : 'inherit'}
																											className={fieldAnexos.link || fieldAnexos.nome ? undefined : "hide" }
																											sx={{overflowWrap:"anywhere"}}
																										>
																											{ field.value }	{/* field.value || (anexoNomeArquivo[index] ? anexoNomeArquivo[index] : '') */}
																										</Button>
																									)}
																								/> 
																							</Grid>

																							<Grid item xs={12} sm={2} lg={1}>
																								{
																									userRoleAdmin && !props.listViews ? 
																									// 	(fieldAnexos.nome && fieldAnexos.nome != "") &&
																											<Button
																												id={'remove_inptAnexo-' + originalIndex}
																												type="button"
																												color="error"
																												fullWidth
																												size="medium"
																												variant="outlined"
																												onClick={() => handleRemoveAnexoItem(originalIndex)}
																												title="Excluir item"
																												sx={botaoIcone}>
																												<DeleteIcon/>
																											</Button> 
																									: ''
																								}
																							</Grid>
																						</Grid>
																					</Paper>
																				</Grid>
																		}
																	</React.Fragment>
																);
															})}
														</Grid>

														{
															// userRoleAdmin && (userRoleAdmin && props.listViews == false)  ?
															userRoleAdmin && !props.listViews ?
																<>
																	<Button
																		component="label"
																		role={undefined}
																		variant="outlined"
																		color="primary"
																		tabIndex={-1}
																		startIcon={<CloudUploadIcon />}
																		id="uploadMultipleAnexos"
																		title="Adicionar anexos"
																		>
																		Adicionar anexos
																		<VisuallyHiddenInput
																			type="file"
																			multiple
																			onChange={(e) => 
																			{
																				const files = Array.from((e.target as HTMLInputElement).files!);
																	
																				if (files)
																				{
																					// Adiciona os arquivos de forma síncrona e adiciona um item "fake" no final
																					files.forEach((file) => 
																					{
																						const simulatedFileList = createSimulatedFileList(file);
																		
																						appendAnexo([
																							{
																								nome: file.name,
																								tipo: TipoAnexo.ANEXO,
																								arquivo: simulatedFileList, // Passa o FileList simulado
																							} as unknown as IPropsAnexo,
																						]);
																					});
																	
																				// Adiciona um item "fake" no final
																					appendAnexo([
																						{
																							nome: "invalid",
																							tipo: TipoAnexo.ANEXO,
																							arquivo: createSimulatedFileList(new File([], "")), // Item "fake" com arquivo vazio
																						} as unknown as IPropsAnexo,
																					]);
																				}
																			}}
																		/>
																	</Button>

																	{/* <Button
																		startIcon={ <PlaylistAddIcon /> }
																		variant="outlined"
																		color="primary"
																		title="Adicionar anexo"
																		onClick={() => {handleAppendAnexoItem()}}
																	>
																		Adicionar anexo
																	</Button> */}
																</>
															: ''
														}
													</Grid>
												</Grid>
											</StyledAccordionDetails>
										</StyledAccordion>
									</Grid>
								}
								{
								//#endregion
								}
								{
								//#region AUTORIZACAO				
								}
								{
									!props.listViews || props.listViews ?
										<Grid item xs={12}>	
											<StyledAccordion expanded={expandedAccordion.indexOf('autorizacoes') >= 0 ? true : false } onChange={() => {handleAccordion('autorizacoes')}}>
												<StyledAccordionSummary aria-controls="anexos-content" id="anexos-header">
													<Typography>Autorizações</Typography>
												</StyledAccordionSummary>
												<StyledAccordionDetails>
													<Grid container spacing={2}>
														<Grid item xs={12}>
														{/*console.log(programaAnexos)*/}
															<Grid container>
																{
																	programaAnexos
																	.filter((fieldAnexos) => fieldAnexos.nome !== "invalid" && fieldAnexos.tipo == TipoAnexo.AUTORIZACAO)
																	.map((fieldAnexos) => 
																	{
																	  
																	const originalIndex = programaAnexos.findIndex(item => item.id === fieldAnexos.id);
																  
																	  return (
																		<React.Fragment key={fieldAnexos.id}>
																			{
																				(fieldAnexos.nome != "invalid" && fieldAnexos.tipo == TipoAnexo.AUTORIZACAO) &&
																					<Grid item xs={12}>
																						<Paper
																							variant={isMenorSM ? 'outlined' : 'elevation'}
																							elevation={isMenorSM ? 1 : 0} // 0 para desabilitar a elevação em resoluções menores que 'sm'
																							sx={{ mb:2, padding:(isMenorSM ? 2 : 0) }}
																						>
																							<Grid container spacing={1} alignItems={"center"}>
																								<Grid item xs={12} sm={10} lg={11} sx={gridAnexos}>
																										
																									<Controller
																										name={`programaAnexos.${originalIndex}.nome`}
																										control={control}
																										render={({ field }) => (
																											<Button
																												id={`programaAnexos.${originalIndex}.nome`}
																												size="medium"
																												variant="text"
																												data-type="buttonLink"
																												href={userRoleAdmin && fieldAnexos.link ? fieldAnexos.link : undefined}
																												endIcon={userRoleAdmin && fieldAnexos.link ? <OpenInNewOutlinedIcon/> : undefined}
																												target={userRoleAdmin && fieldAnexos.link ? '_blank' : undefined}
																												color={userRoleAdmin && fieldAnexos.link ? undefined : 'inherit'}
																												className={fieldAnexos.link || fieldAnexos.nome ? undefined : "hide" }
																												sx={{overflowWrap:"anywhere"}}
																											>
																												{ field.value } {/* field.value || (anexoNomeArquivo[index] ? anexoNomeArquivo[index] : '') */}
																											</Button>
																										)}
																									/> 
																								</Grid>

																								<Grid item xs={12} sm={2} lg={1}>
																									{
																										userRoleAdmin && !props.listViews ? 
																										// 	(fieldAnexos.nome && fieldAnexos.nome != "") &&
																												<Button
																													id={'remove_inptAnexo-' + originalIndex}
																													type="button"
																													color="error"
																													fullWidth
																													size="medium"
																													variant="outlined"
																													onClick={() => handleRemoveAnexoItem(originalIndex)}
																													title="Excluir item"
																													sx={botaoIcone}>
																													<DeleteIcon/>
																												</Button> 
																										: ''
																									}
																								</Grid>
																							</Grid>
																						</Paper>
																					</Grid>
																			}
																		</React.Fragment>
																	);
																})}
															</Grid>

															{
																// userRoleAdmin && (userRoleAdmin && props.listViews == false)  ?
																userRoleAdmin && !props.listViews ?
																	<>
																		<Button
																			component="label"
																			role={undefined}
																			variant="outlined"
																			color="primary"
																			tabIndex={-1}
																			startIcon={<CloudUploadIcon />}
																			id="uploadMultipleAutorizacoes"
																			title="Adicionar autorizações"
																			>
																			Adicionar autorizações
																			<VisuallyHiddenInput
																				type="file"
																				multiple
																				onChange={(e) => 
																				{
																					const files = Array.from((e.target as HTMLInputElement).files!);
																			
																					if (files)
																					{
																						// Adiciona os arquivos de forma síncrona e adiciona um item "fake" no final
																						files.forEach((file) => 
																						{
																							const simulatedFileList = createSimulatedFileList(file);
																				
																							appendAnexo([
																								{
																									nome: file.name,
																									tipo: TipoAnexo.AUTORIZACAO,
																									arquivo: simulatedFileList, // Passa o FileList simulado
																								} as unknown as IPropsAnexo,
																							]);
																						});
																			
																					// Adiciona um item "fake" no final
																						appendAnexo([
																							{
																								nome: "invalid",
																								tipo: TipoAnexo.AUTORIZACAO,
																								arquivo: createSimulatedFileList(new File([], "")), // Item "fake" com arquivo vazio
																							} as unknown as IPropsAnexo,
																						]);
																					}
																				}}
																			/>
																		</Button>

																		{/* <Button
																			startIcon={ <PlaylistAddIcon /> }
																			variant="outlined"
																			color="primary"
																			title="Adicionar anexo"
																			onClick={() => {handleAppendAnexoItem()}}
																		>
																			Adicionar anexo
																		</Button> */}
																	</>
																: ''
															}
														</Grid>
													</Grid>
												</StyledAccordionDetails>
											</StyledAccordion>
										</Grid> : ''
								}
								{
								//#endregion
								}
								{
								//#region PLANILHAS MUSICAIS				
								}
								{
									!props.listViews || props.listViews ?
										<Grid item xs={12}>	
											<StyledAccordion expanded={expandedAccordion.indexOf('planilhasMusicais') >= 0 ? true : false } onChange={() => {handleAccordion('planilhasMusicais')}}>
												<StyledAccordionSummary aria-controls="anexos-content" id="anexos-header">
													<Typography>Planilhas Musicais</Typography>
												</StyledAccordionSummary>
												<StyledAccordionDetails>
													<Grid container spacing={2}>
														<Grid item xs={12}>
														{/*console.log(programaAnexos)*/}
															<Grid container>
																{
																	programaAnexos
																	.filter((fieldAnexos) => fieldAnexos.nome !== "invalid" && fieldAnexos.tipo == TipoAnexo.PLANILHA_MUSICAL)
																	.map((fieldAnexos) => 
																	{
																	  
																	const originalIndex = programaAnexos.findIndex(item => item.id === fieldAnexos.id);
																  
																	  return (
																		<React.Fragment key={fieldAnexos.id}>
																			{
																				(fieldAnexos.nome != "invalid" && fieldAnexos.tipo == TipoAnexo.PLANILHA_MUSICAL) &&
																					<Grid item xs={12}>
																						<Paper
																							variant={isMenorSM ? 'outlined' : 'elevation'}
																							elevation={isMenorSM ? 1 : 0} // 0 para desabilitar a elevação em resoluções menores que 'sm'
																							sx={{ mb:2, padding:(isMenorSM ? 2 : 0) }}
																						>
																							<Grid container spacing={1} alignItems={"center"}>
																								<Grid item xs={12} sm={10} lg={11} sx={gridAnexos}>
																										
																									<Controller
																										name={`programaAnexos.${originalIndex}.nome`}
																										control={control}
																										render={({ field }) => (
																											<Button
																												id={`programaAnexos.${originalIndex}.nome`}
																												size="medium"
																												variant="text"
																												data-type="buttonLink"
																												href={userRoleAdmin && fieldAnexos.link ? fieldAnexos.link : undefined}
																												endIcon={userRoleAdmin && fieldAnexos.link ? <OpenInNewOutlinedIcon/> : undefined}
																												target={userRoleAdmin && fieldAnexos.link ? '_blank' : undefined}
																												color={userRoleAdmin && fieldAnexos.link ? undefined : 'inherit'}
																												className={fieldAnexos.link || fieldAnexos.nome ? undefined : "hide" }
																												sx={{overflowWrap:"anywhere"}}
																											>
																												{ field.value } {/* field.value || (anexoNomeArquivo[index] ? anexoNomeArquivo[index] : '') */}
																											</Button>
																										)}
																									/> 
																								</Grid>

																								<Grid item xs={12} sm={2} lg={1}>
																									{
																										userRoleAdmin && !props.listViews ? 
																										// 	(fieldAnexos.nome && fieldAnexos.nome != "") &&
																												<Button
																													id={'remove_inptAnexo-' + originalIndex}
																													type="button"
																													color="error"
																													fullWidth
																													size="medium"
																													variant="outlined"
																													onClick={() => handleRemoveAnexoItem(originalIndex)}
																													title="Excluir item"
																													sx={botaoIcone}>
																													<DeleteIcon/>
																												</Button> 
																										: ''
																									}
																								</Grid>
																							</Grid>
																						</Paper>
																					</Grid>
																			}
																		</React.Fragment>
																	);
																})}
															</Grid>

															{
																// userRoleAdmin && (userRoleAdmin && props.listViews == false)  ?
																userRoleAdmin && !props.listViews ?
																	<>
																		<Button
																			component="label"
																			role={undefined}
																			variant="outlined"
																			color="primary"
																			tabIndex={-1}
																			startIcon={<CloudUploadIcon />}
																			id="uploadMultipleplanilhasMusicais"
																			title="Adicionar planilhas musicais"
																			>
																			Adicionar planilhas musicais
																			<VisuallyHiddenInput
																				type="file"
																				multiple
																				onChange={(e) => 
																				{
																					const files = Array.from((e.target as HTMLInputElement).files!);
																			
																					if (files)
																					{
																						// Adiciona os arquivos de forma síncrona e adiciona um item "fake" no final
																						files.forEach((file) => 
																						{
																							const simulatedFileList = createSimulatedFileList(file);
																				
																							appendAnexo([
																								{
																									nome: file.name,
																									tipo: TipoAnexo.PLANILHA_MUSICAL,
																									arquivo: simulatedFileList, // Passa o FileList simulado
																								} as unknown as IPropsAnexo,
																							]);
																						});
																			
																					// Adiciona um item "fake" no final
																						appendAnexo([
																							{
																								nome: "invalid",
																								tipo: TipoAnexo.PLANILHA_MUSICAL,
																								arquivo: createSimulatedFileList(new File([], "")), // Item "fake" com arquivo vazio
																							} as unknown as IPropsAnexo,
																						]);
																					}
																				}}
																			/>
																		</Button>

																		{/* <Button
																			startIcon={ <PlaylistAddIcon /> }
																			variant="outlined"
																			color="primary"
																			title="Adicionar anexo"
																			onClick={() => {handleAppendAnexoItem()}}
																		>
																			Adicionar anexo
																		</Button> */}
																	</>
																: ''
															}
														</Grid>
													</Grid>
												</StyledAccordionDetails>
											</StyledAccordion>
										</Grid> : ''
								}
								{
								//#endregion
								}
								{
								//#region MATERIAIS DE DIVULGAÇÃO
								}
								{
									!props.listViews || props.listViews ?
										<Grid item xs={12}>	
											<StyledAccordion expanded={expandedAccordion.indexOf('materiaisDivulgacao') >= 0 ? true : false } onChange={() => {handleAccordion('materiaisDivulgacao')}}>
												<StyledAccordionSummary aria-controls="anexos-content" id="anexos-header">
													<Typography>Materiais de Divulgação</Typography>
												</StyledAccordionSummary>
												<StyledAccordionDetails>
													<Grid container spacing={2}>
														<Grid item xs={12}>
														{/*console.log(programaAnexos)*/}
															<Grid container>
																{
																	programaAnexos
																	.filter((fieldAnexos) => fieldAnexos.nome !== "invalid" && fieldAnexos.tipo == TipoAnexo.MATERIAL_DIVULGACAO)
																	.map((fieldAnexos) => 
																	{
																	  
																	const originalIndex = programaAnexos.findIndex(item => item.id === fieldAnexos.id);
																  
																	  return (
																		<React.Fragment key={fieldAnexos.id}>
																			{
																				(fieldAnexos.nome != "invalid" && fieldAnexos.tipo == TipoAnexo.MATERIAL_DIVULGACAO) &&
																					<Grid item xs={12}>
																						<Paper
																							variant={isMenorSM ? 'outlined' : 'elevation'}
																							elevation={isMenorSM ? 1 : 0} // 0 para desabilitar a elevação em resoluções menores que 'sm'
																							sx={{ mb:2, padding:(isMenorSM ? 2 : 0) }}
																						>
																							<Grid container spacing={1} alignItems={"center"}>
																								<Grid item xs={12} sm={10} lg={11} sx={gridAnexos}>
																										
																									<Controller
																										name={`programaAnexos.${originalIndex}.nome`}
																										control={control}
																										render={({ field }) => (
																											<Button
																												id={`programaAnexos.${originalIndex}.nome`}
																												size="medium"
																												variant="text"
																												data-type="buttonLink"
																												href={userRoleAdmin && fieldAnexos.link ? fieldAnexos.link : undefined}
																												endIcon={userRoleAdmin && fieldAnexos.link ? <OpenInNewOutlinedIcon/> : undefined}
																												target={userRoleAdmin && fieldAnexos.link ? '_blank' : undefined}
																												color={userRoleAdmin && fieldAnexos.link ? undefined : 'inherit'}
																												className={fieldAnexos.link || fieldAnexos.nome ? undefined : "hide" }
																												sx={{overflowWrap:"anywhere"}}
																											>
																												{ field.value } {/* field.value || (anexoNomeArquivo[index] ? anexoNomeArquivo[index] : '') */}
																											</Button>
																										)}
																									/> 
																								</Grid>

																								<Grid item xs={12} sm={2} lg={1}>
																									{
																										userRoleAdmin && !props.listViews ? 
																										// 	(fieldAnexos.nome && fieldAnexos.nome != "") &&
																												<Button
																													id={'remove_inptAnexo-' + originalIndex}
																													type="button"
																													color="error"
																													fullWidth
																													size="medium"
																													variant="outlined"
																													onClick={() => handleRemoveAnexoItem(originalIndex)}
																													title="Excluir item"
																													sx={botaoIcone}>
																													<DeleteIcon/>
																												</Button> 
																										: ''
																									}
																								</Grid>
																							</Grid>
																						</Paper>
																					</Grid>
																			}
																		</React.Fragment>
																	);
																})}
															</Grid>

															{
																// userRoleAdmin && (userRoleAdmin && props.listViews == false)  ?
																userRoleAdmin && !props.listViews ?
																	<>
																		<Button
																			component="label"
																			role={undefined}
																			variant="outlined"
																			color="primary"
																			tabIndex={-1}
																			startIcon={<CloudUploadIcon />}
																			id="uploadMultiplemateriaisDivulgacao"
																			title="Adicionar materiais de divulgação"
																			>
																			Adicionar materiais de divulgação
																			<VisuallyHiddenInput
																				type="file"
																				multiple
																				onChange={(e) => 
																				{
																					const files = Array.from((e.target as HTMLInputElement).files!);
																			
																					if (files)
																					{
																						// Adiciona os arquivos de forma síncrona e adiciona um item "fake" no final
																						files.forEach((file) => 
																						{
																							const simulatedFileList = createSimulatedFileList(file);
																				
																							appendAnexo([
																								{
																									nome: file.name,
																									tipo: TipoAnexo.MATERIAL_DIVULGACAO,
																									arquivo: simulatedFileList, // Passa o FileList simulado
																								} as unknown as IPropsAnexo,
																							]);
																						});
																			
																					// Adiciona um item "fake" no final
																						appendAnexo([
																							{
																								nome: "invalid",
																								tipo: TipoAnexo.MATERIAL_DIVULGACAO,
																								arquivo: createSimulatedFileList(new File([], "")), // Item "fake" com arquivo vazio
																							} as unknown as IPropsAnexo,
																						]);
																					}
																				}}
																			/>
																		</Button>

																		{/* <Button
																			startIcon={ <PlaylistAddIcon /> }
																			variant="outlined"
																			color="primary"
																			title="Adicionar anexo"
																			onClick={() => {handleAppendAnexoItem()}}
																		>
																			Adicionar anexo
																		</Button> */}
																	</>
																: ''
															}
														</Grid>
													</Grid>
												</StyledAccordionDetails>
											</StyledAccordion>
										</Grid> : ''
								}
								{
								//#endregion
								}
								{
								//#region RECURSOS DE ACESSIBILIDADE
								}
								{
									!props.listViews || props.listViews ?
										<Grid item xs={12}>	
											<StyledAccordion expanded={expandedAccordion.indexOf('recursosAcessibilidade') >= 0 ? true : false } onChange={() => {handleAccordion('recursosAcessibilidade')}}>
												<StyledAccordionSummary aria-controls="anexos-content" id="anexos-header">
													<Typography>Recursos de Acessibilidade</Typography>
												</StyledAccordionSummary>
												<StyledAccordionDetails>
													<Grid container spacing={2}>
														<Grid item xs={12}>
														{/*console.log(programaAnexos)*/}
															<Grid container>
																{
																	programaAnexos
																	.filter((fieldAnexos) => fieldAnexos.nome !== "invalid" && fieldAnexos.tipo == TipoAnexo.RECURSO_ACESSIBILIDADE)
																	.map((fieldAnexos) => 
																	{
																	  
																	const originalIndex = programaAnexos.findIndex(item => item.id === fieldAnexos.id);
																  
																	  return (
																		<React.Fragment key={fieldAnexos.id}>
																			{
																				(fieldAnexos.nome != "invalid" && fieldAnexos.tipo == TipoAnexo.RECURSO_ACESSIBILIDADE) &&
																					<Grid item xs={12}>
																						<Paper
																							variant={isMenorSM ? 'outlined' : 'elevation'}
																							elevation={isMenorSM ? 1 : 0} // 0 para desabilitar a elevação em resoluções menores que 'sm'
																							sx={{ mb:2, padding:(isMenorSM ? 2 : 0) }}
																						>
																							<Grid container spacing={1} alignItems={"center"}>
																								<Grid item xs={12} sm={10} lg={11} sx={gridAnexos}>
																										
																									<Controller
																										name={`programaAnexos.${originalIndex}.nome`}
																										control={control}
																										render={({ field }) => (
																											<Button
																												id={`programaAnexos.${originalIndex}.nome`}
																												size="medium"
																												variant="text"
																												data-type="buttonLink"
																												href={userRoleAdmin && fieldAnexos.link ? fieldAnexos.link : undefined}
																												endIcon={userRoleAdmin && fieldAnexos.link ? <OpenInNewOutlinedIcon/> : undefined}
																												target={userRoleAdmin && fieldAnexos.link ? '_blank' : undefined}
																												color={userRoleAdmin && fieldAnexos.link ? undefined : 'inherit'}
																												className={fieldAnexos.link || fieldAnexos.nome ? undefined : "hide" }
																												sx={{overflowWrap:"anywhere"}}
																											>
																												{ field.value }	{/* field.value || (anexoNomeArquivo[index] ? anexoNomeArquivo[index] : '') */}
																											</Button>
																										)}
																									/> 
																								</Grid>

																								<Grid item xs={12} sm={2} lg={1}>
																									{
																										userRoleAdmin && !props.listViews ? 
																										// 	(fieldAnexos.nome && fieldAnexos.nome != "") &&
																												<Button
																													id={'remove_inptAnexo-' + originalIndex}
																													type="button"
																													color="error"
																													fullWidth
																													size="medium"
																													variant="outlined"
																													onClick={() => handleRemoveAnexoItem(originalIndex)}
																													title="Excluir item"
																													sx={botaoIcone}>
																													<DeleteIcon/>
																												</Button> 
																										: ''
																									}
																								</Grid>
																							</Grid>
																						</Paper>
																					</Grid>
																			}
																		</React.Fragment>
																	);
																})}
															</Grid>

															{
																// userRoleAdmin && (userRoleAdmin && props.listViews == false)  ?
																userRoleAdmin && !props.listViews ?
																	<>
																		<Button
																			component="label"
																			role={undefined}
																			variant="outlined"
																			color="primary"
																			tabIndex={-1}
																			startIcon={<CloudUploadIcon />}
																			id="uploadMultiplerecursosAcessibilidade"
																			title="Adicionar recursos de acessibilidade"
																			>
																			Adicionar recursos de acessibilidade
																			<VisuallyHiddenInput
																				type="file"
																				multiple
																				onChange={(e) => 
																				{
																					const files = Array.from((e.target as HTMLInputElement).files!);
																			
																					if (files)
																					{
																						// Adiciona os arquivos de forma síncrona e adiciona um item "fake" no final
																						files.forEach((file) => 
																						{
																							const simulatedFileList = createSimulatedFileList(file);
																				
																							appendAnexo([
																								{
																									nome: file.name,
																									tipo: TipoAnexo.RECURSO_ACESSIBILIDADE,
																									arquivo: simulatedFileList, // Passa o FileList simulado
																								} as unknown as IPropsAnexo,
																							]);
																						});
																			
																					// Adiciona um item "fake" no final
																						appendAnexo([
																							{
																								nome: "invalid",
																								tipo: TipoAnexo.RECURSO_ACESSIBILIDADE,
																								arquivo: createSimulatedFileList(new File([], "")), // Item "fake" com arquivo vazio
																							} as unknown as IPropsAnexo,
																						]);
																					}
																				}}
																			/>
																		</Button>

																		{/* <Button
																			startIcon={ <PlaylistAddIcon /> }
																			variant="outlined"
																			color="primary"
																			title="Adicionar anexo"
																			onClick={() => {handleAppendAnexoItem()}}
																		>
																			Adicionar anexo
																		</Button> */}
																	</>
																: ''
															}
														</Grid>
													</Grid>
												</StyledAccordionDetails>
											</StyledAccordion>
										</Grid> : ''
								}
								{
								//#endregion
								}
								{
								//#region OUTROS ANEXOS
								}
								{
									!props.listViews || props.listViews ?
										<Grid item xs={12}>	
											<StyledAccordion expanded={expandedAccordion.indexOf('anexosOutros') >= 0 ? true : false } onChange={() => {handleAccordion('anexosOutros')}}>
												<StyledAccordionSummary aria-controls="anexos-content" id="anexos-header">
													<Typography>Outros Documentos</Typography>
												</StyledAccordionSummary>
												<StyledAccordionDetails>
													<Grid container spacing={2}>
														<Grid item xs={12}>
														{/*console.log(programaAnexos)*/}
															<Grid container>
																{
																	programaAnexos
																	.filter((fieldAnexos) => fieldAnexos.nome !== "invalid" && fieldAnexos.tipo == TipoAnexo.OUTRO)
																	.map((fieldAnexos) => 
																	{
																	  
																	const originalIndex = programaAnexos.findIndex(item => item.id === fieldAnexos.id);
																  
																	  return (
																		<React.Fragment key={fieldAnexos.id}>
																			{
																				(fieldAnexos.nome != "invalid" && fieldAnexos.tipo == TipoAnexo.OUTRO) &&
																					<Grid item xs={12}>
																						<Paper
																							variant={isMenorSM ? 'outlined' : 'elevation'}
																							elevation={isMenorSM ? 1 : 0} // 0 para desabilitar a elevação em resoluções menores que 'sm'
																							sx={{ mb:2, padding:(isMenorSM ? 2 : 0) }}
																						>
																							<Grid container spacing={1} alignItems={"center"}>
																								<Grid item xs={12} sm={10} lg={11} sx={gridAnexos}>
																										
																									<Controller
																										name={`programaAnexos.${originalIndex}.nome`}
																										control={control}
																										render={({ field }) => (
																											<Button
																												id={`programaAnexos.${originalIndex}.nome`}
																												size="medium"
																												variant="text"
																												data-type="buttonLink"
																												href={userRoleAdmin && fieldAnexos.link ? fieldAnexos.link : undefined}
																												endIcon={userRoleAdmin && fieldAnexos.link ? <OpenInNewOutlinedIcon/> : undefined}
																												target={userRoleAdmin && fieldAnexos.link ? '_blank' : undefined}
																												color={userRoleAdmin && fieldAnexos.link ? undefined : 'inherit'}
																												className={fieldAnexos.link || fieldAnexos.nome ? undefined : "hide" }
																												sx={{overflowWrap:"anywhere"}}
																											>
																												{ field.value }	{/* field.value || (anexoNomeArquivo[index] ? anexoNomeArquivo[index] : '') */}
																											</Button>
																										)}
																									/> 
																								</Grid>

																								<Grid item xs={12} sm={2} lg={1}>
																									{
																										userRoleAdmin && !props.listViews ? 
																										// 	(fieldAnexos.nome && fieldAnexos.nome != "") &&
																												<Button
																													id={'remove_inptAnexo-' + originalIndex}
																													type="button"
																													color="error"
																													fullWidth
																													size="medium"
																													variant="outlined"
																													onClick={() => handleRemoveAnexoItem(originalIndex)}
																													title="Excluir item"
																													sx={botaoIcone}>
																													<DeleteIcon/>
																												</Button> 
																										: ''
																									}
																								</Grid>
																							</Grid>
																						</Paper>
																					</Grid>
																			}
																		</React.Fragment>
																	);
																})}
															</Grid>

															{
																// userRoleAdmin && (userRoleAdmin && props.listViews == false)  ?
																userRoleAdmin && !props.listViews ?
																	<>
																		<Button
																			component="label"
																			role={undefined}
																			variant="outlined"
																			color="primary"
																			tabIndex={-1}
																			startIcon={<CloudUploadIcon />}
																			id="uploadMultipleanexosOutros"
																			title="Adicionar outros documentos"
																			>
																			Adicionar outros documentos
																			<VisuallyHiddenInput
																				type="file"
																				multiple
																				onChange={(e) => 
																				{
																					const files = Array.from((e.target as HTMLInputElement).files!);
																			
																					if (files)
																					{
																						// Adiciona os arquivos de forma síncrona e adiciona um item "fake" no final
																						files.forEach((file) => 
																						{
																							const simulatedFileList = createSimulatedFileList(file);
																				
																							appendAnexo([
																								{
																									nome: file.name,
																									tipo: TipoAnexo.OUTRO,
																									arquivo: simulatedFileList, // Passa o FileList simulado
																								} as unknown as IPropsAnexo,
																							]);
																						});
																			
																					// Adiciona um item "fake" no final
																						appendAnexo([
																							{
																								nome: "invalid",
																								tipo: TipoAnexo.OUTRO,
																								arquivo: createSimulatedFileList(new File([], "")), // Item "fake" com arquivo vazio
																							} as unknown as IPropsAnexo,
																						]);
																					}
																				}}
																			/>
																		</Button>

																		{/* <Button
																			startIcon={ <PlaylistAddIcon /> }
																			variant="outlined"
																			color="primary"
																			title="Adicionar anexo"
																			onClick={() => {handleAppendAnexoItem()}}
																		>
																			Adicionar anexo
																		</Button> */}
																	</>
																: ''
															}
														</Grid>
													</Grid>
												</StyledAccordionDetails>
											</StyledAccordion>
										</Grid> : ''
								}
								{
								//#endregion
								}
								
							</CustomTabPanel>					
					}
					
				</AddEditComponent>
			</>
			/* Outros elementos que você quiser ... */
		}
	</>
}
export default FormDialog;

interface TabPanelProps
{
	children?: React.ReactNode;
	index: number;
	value: number;
}

function CustomTabPanel(props: TabPanelProps)
{
	const { children, value, index } = props;
	
	return value === index ? <>{children}</> : null;
}

const gridAnexos = {
	'& .hide': {
		position: 'absolute',
		width: 0,
		height: 0,
		overflow: 'hidden',
		opacity: 0,
	},
}

const botaoIcone = {
	minWidth: 'inherit',
	width: 'calc(50% + 5px)',
	cursor: 'pointer'
}
const botaoCopy = {
	minWidth: 'inherit',
	width: 'calc(50% + 5px)',
	margin: '0 0 0 10px',
	cursor: 'pointer'
}
const botaoIconeDelete = {
	minWidth: 'inherit',
	cursor: 'pointer'
}